


// import React, { useEffect, useState, useRef } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   Container,
//   Box,
//   Typography,
//   Paper,
//   Divider,
//   Button,
//   Avatar,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   TextField,
//   Grid,
//   Tooltip,
//   CircularProgress,
//   Chip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Card,
//   CardContent,
//   Alert,
//   Snackbar,
// } from "@mui/material";
// import {
//   ArrowBack,
//   Print,
//   Download,
//   LocalHospital,
//   Person,
//   Receipt,
//   Phone,
//   Email,
//   Language,
//   Home,
//   CalendarToday,
//   Male,
//   Female,
//   ReceiptLong,
//   ContentCopy,
// } from "@mui/icons-material";
// import { styled } from "@mui/material/styles";
// import logo from "../assets/AuraLogo.png";
// import html2pdf from "html2pdf.js";
// import { NumericFormat } from 'react-number-format';
// import qz from "qz-tray";

// const PRINTER_NAME = "BIXOLON SRP-E302"; // Change to your thermal printer name

// // Enhanced Cash drawer commands for thermal printers
// const CASH_DRAWER_COMMANDS = {
//   OPEN_DRAWER_PIN2: "\x1B\x70\x00\x19\xFA",
//   OPEN_DRAWER_PIN5: "\x1B\x70\x01\x19\xFA",
//   ALTERNATE_1: "\x1B\x70\x00\x60\x60",
//   ALTERNATE_2: "\x1B\x70\x01\x60\x60",
//   BELL_COMMAND: "\x07",
// };

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(4),
//   marginTop: theme.spacing(3),
//   borderRadius: theme.shape.borderRadius * 2,
//   boxShadow: theme.shadows[3],
//   maxWidth: 1500,
//   margin: "0 auto",
//   "@media print": {
//     boxShadow: "none",
//     padding: theme.spacing(3),
//     border: "1px solid #ddd",
//   },
// }));

// const HeaderBox = styled(Box)(({ theme }) => ({
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   marginBottom: theme.spacing(4),
//   "@media (max-width: 600px)": {
//     flexDirection: "column",
//     gap: theme.spacing(2),
//     alignItems: "flex-start",
//   },
//   "@media print": {
//     flexDirection: "row",
//     alignItems: "center",
//   },
// }));

// const TotalRow = styled(TableRow)(({ theme }) => ({
//   backgroundColor: theme.palette.grey[100],
//   "& td": {
//     fontWeight: "bold",
//     fontSize: "1.1rem",
//   },
// }));

// const DiscountRow = styled(TableRow)(({ theme }) => ({
//   backgroundColor: theme.palette.grey[50],
//   "& td": {
//     padding: theme.spacing(2),
//   },
// }));

// const InvoiceNumberBox = styled(Box)(({ theme }) => ({
//   backgroundColor: theme.palette.secondary.main,
//   color: 'white',
//   padding: '6px 12px',
//   borderRadius: '16px',
//   display: 'inline-block',
//   marginTop: theme.spacing(1),
//   fontSize: '0.875rem',
//   fontWeight: 500,
//   '-webkit-print-color-adjust': 'exact',
//   'color-adjust': 'exact',
//   'print-color-adjust': 'exact',
// }));

// // QZ Tray Thermal Printing Component
// const QZTrayThermalPrint = ({ 
//   open, 
//   onClose, 
//   patients, 
//   invoicedetails, 
//   treatmentamount, 
//   discount, 
//   discountType, 
//   calculateSubtotal, 
//   calculateTotalAmount 
// }) => {
//   const [printStatus, setPrintStatus] = useState({ open: false, message: '', severity: 'info' });
//   const [isPrinting, setIsPrinting] = useState(false);
//   const [isOpeningDrawer, setIsOpeningDrawer] = useState(false);

//   const showMessage = (message, severity = 'info') => {
//     setPrintStatus({ open: true, message, severity });
//   };

//   // Thermal printer formatting constants
//   const esc = "\x1B";
//   const gs = "\x1D";
//   const LINE_WIDTH = 48; // 80mm thermal printer width

//   const leftRight = (left, right, width = LINE_WIDTH) => {
//     const space = width - (left.length + right.length);
//     return left + " ".repeat(space > 0 ? space : 1) + right;
//   };

//   const centerText = (text, width = LINE_WIDTH) => {
//     const padding = Math.max(0, Math.floor((width - text.length) / 2));
//     return " ".repeat(padding) + text;
//   };

//   const divider = (char = "-") => char.repeat(LINE_WIDTH) + "\n";

//   const formatCurrency = (value) => {
//     return new Intl.NumberFormat('en-US', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(Number(value));
//   };

//   // Enhanced Cash Drawer Function
//   const openCashDrawer = async () => {
//     try {
//       console.log("Attempting to open cash drawer...");
      
//       if (!qz.websocket.isActive()) {
//         await qz.websocket.connect();
//       }
      
//       const config = qz.configs.create(PRINTER_NAME);
      
//       // Try different cash drawer commands in sequence
//       const commands = [
//         CASH_DRAWER_COMMANDS.OPEN_DRAWER_PIN2,
//         CASH_DRAWER_COMMANDS.OPEN_DRAWER_PIN5,
//         CASH_DRAWER_COMMANDS.ALTERNATE_1,
//         CASH_DRAWER_COMMANDS.ALTERNATE_2,
//         CASH_DRAWER_COMMANDS.BELL_COMMAND
//       ];
      
//       let drawerOpened = false;
//       let lastError = null;
      
//       for (const command of commands) {
//         try {
//           console.log(`Trying cash drawer command: ${Array.from(command).map(c => c.charCodeAt(0))}`);
//           await qz.print(config, [{ type: "raw", format: "command", data: command }]);
//           console.log("Cash drawer command sent successfully");
//           drawerOpened = true;
//           break;
//         } catch (error) {
//           console.warn(`Cash drawer command failed: ${error.message}`);
//           lastError = error;
//         }
//       }
      
//       if (!drawerOpened) {
//         console.error("All cash drawer commands failed", lastError);
//         throw new Error(`Cash drawer failed to open: ${lastError?.message || 'Unknown error'}`);
//       }
      
//       return drawerOpened;
//     } catch (error) {
//       console.error("Cash drawer error:", error);
//       throw error;
//     }
//   };

//   // Generate thermal receipt commands for QZ Tray
//   const generateThermalReceipt = () => {
//     const subtotal = Number(calculateSubtotal()) + Number(treatmentamount);
//     const totalAmount = Number(calculateTotalAmount());
    
//     const lines = [
//       esc + "@", // Initialize printer
      
//       // Company header - Center aligned and emphasized
//       esc + "a" + "\x01", // Center align
//       esc + "!" + "\x38", // Double height and emphasized
//       "AURA MEDITATION\n",
//       esc + "!" + "\x00", // Cancel text formatting
      
//       // Company details
//       esc + "!" + "\x08", // Emphasized
//       "No:128/1,Pahala karagahamuna,Kadawatha.\n",
//       "Tel: 0114532108 | 0117905805\n",
//       "Email: akdldhshana@gmail.com\n",
//       esc + "!" + "\x00", // Cancel emphasis
      
//       divider("="),
      
//       // Receipt title
      
//       esc + "!" + "\x12", // Medium size
//        esc + "a" + "\x01", // Center align
//       esc + "!" + "\x28", // Double height and emphasized
//       "PAYMENT RECEIPT\n",
//       esc + "!" + "\x00", // Cancel size
//       divider("="),
      
//       // Invoice info
//       leftRight("Invoice:", invoicedetails?.MTD_SERIAL_NO || 'N/A') + "\n",
//       leftRight("Date:", new Date().toLocaleDateString('en-GB')) + "\n",
//       leftRight("Time:", new Date().toLocaleTimeString('en-GB', { 
//         hour: '2-digit', 
//         minute: '2-digit',
//         hour12: false 
//       })) + "\n",
      
//     divider("-"),
// esc + "a" + "\x01" + "PATIENT DETAILS" + "\n" + esc + "a" + "\x00",
// divider("-"),


      
      
//       // Patient details - Left aligned
// `Name: ${patients?.MPD_PATIENT_NAME || 'N/A'}\n`,
// `Address: ${(patients?.MPD_ADDRESS || 'Not specified').substring(0, 30)}\n`,
// `Gender/Age: ${patients?.MPD_GENDER || 'N/A'}/${
//   patients?.MPD_BIRTHDAY ? 
//   new Date().getFullYear() - new Date(patients.MPD_BIRTHDAY).getFullYear() : 'N/A'
// }\n`,
      
//       divider("-"),
//       centerText("BILLING DETAILS") + "\n",
//       divider("-"),
      
//       // Items header
//       esc + "!" + "\x08", // Emphasized
//       leftRight("Item", "Qty  Price   Amount") + "\n",
//       esc + "!" + "\x00", // Cancel emphasis
//       divider("-"),
//     ];

//     // Add medicine items
//     if (invoicedetails?.Drugs && invoicedetails.Drugs.length > 0) {
//       invoicedetails.Drugs.forEach(medicinedetail => {
//         const name = medicinedetail.MMC_MATERIAL_SPEC.length > 20 ? 
//           medicinedetail.MMC_MATERIAL_SPEC.substring(0, 20) : medicinedetail.DrugName;
//         const qty = medicinedetail.MDD_QUANTITY.toString().padStart(2);
//         const rate = formatCurrency(medicinedetail.MDD_RATE).padStart(6);
//         const amount = formatCurrency(medicinedetail.MDD_AMOUNT).padStart(8);
        
//         lines.push(leftRight(name, `${qty}  ${rate} ${amount}`) + "\n");
//       });
//     } else {
//       lines.push(centerText("No Drug / Service") + "\n");
//     }

//     // Add totals
//     lines.push(
//       divider("-"),
//       ...(invoicedetails?.Drugs?.length > 0 ? [
//         leftRight("Drug / Service Subtotal:", `Rs. ${formatCurrency(calculateSubtotal())}`) + "\n"
//       ] : []),
//       leftRight("Treatment Fee:", `Rs. ${formatCurrency(treatmentamount)}`) + "\n",
//       leftRight("Subtotal:", `Rs. ${formatCurrency(subtotal)}`) + "\n",
//       ...(discount > 0 ? [
//         leftRight(
//           "Discount:", 
//           discountType === 'percentage' ? 
//           `-${discount}%` : 
//           `-Rs. ${formatCurrency(discount)}`
//         ) + "\n"
//       ] : []),
//       divider("="),
//       esc + "!" + "\x18", // Medium size
//       leftRight("TOTAL:", `Rs. ${formatCurrency(totalAmount)}`) + "\n",
//       esc + "!" + "\x00", // Cancel size
//       divider("="),
//       "\n",
//       centerText("THANK YOU!") + "\n",
//       centerText("Aura Meditation") + "\n",
//       // "\n",
//       // centerText("Authorized Signature") + "\n",
//       // "\n",
//       divider("*"),
//       centerText(new Date().toLocaleString('en-GB')) + "\n",
//       "\n\n\n\n\n", // Extra lines for paper cut
//       gs + "V" + "\x41" + "\x03" // Cut paper
//     );

//     return lines.join("");
//   };

//   const printThermalReceipt = async () => {
//     if (isPrinting) return;
    
//     setIsPrinting(true);
    
//     try {
//       // Connect to printer first
//       if (!qz.websocket.isActive()) {
//         await qz.websocket.connect();
//       }
//       const config = qz.configs.create(PRINTER_NAME);

//       const printData = generateThermalReceipt();

//       // Print the receipt
//       console.log("Printing thermal receipt...");
//       await qz.print(config, [{ type: "raw", format: "command", data: printData }]);
//       console.log("Thermal receipt printed successfully");

//       showMessage('Thermal receipt printed successfully!', 'success');
//       onClose();
//     } catch (err) {
//       console.error("Print process failed:", err);
//       showMessage("Print error: " + err.message, 'error');
//     } finally {
//       setIsPrinting(false);
//     }
//   };

//   // Separate function to just open cash drawer
//   const handleOpenCashDrawer = async () => {
//     if (isOpeningDrawer) return;
    
//     setIsOpeningDrawer(true);
//     try {
//       await openCashDrawer();
//       showMessage("Cash drawer opened successfully!", 'success');
//     } catch (error) {
//       console.error("Cash drawer error:", error);
//       showMessage("Error opening cash drawer: " + error.message, 'error');
//     } finally {
//       setIsOpeningDrawer(false);
//     }
//   };

//   return (
//     <>
//       <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
//         <DialogTitle>
//           <Box display="flex" alignItems="center" gap={1}>
//             <ReceiptLong color="primary" />
//             QZ Tray Thermal Printing
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//             Direct printing to thermal printer using QZ Tray
//           </Typography>
          
//           <Card variant="outlined" sx={{ mb: 3 }}>
//             <CardContent>
//               <Typography variant="h6" gutterBottom>
//                 Receipt Preview (Thermal Format)
//               </Typography>
//               <Paper 
//                 variant="outlined" 
//                 sx={{ 
//                   p: 2, 
//                   backgroundColor: '#f5f5f5', 
//                   fontFamily: 'Courier New, monospace', 
//                   fontSize: '12px', 
//                   lineHeight: '1.2', 
//                   whiteSpace: 'pre',
//                   maxHeight: '400px',
//                   overflow: 'auto',
//                   border: '1px dashed #ccc'
//                 }}
//               >
//                 {generateThermalReceipt().replace(/\x1B\[.*?m/g, '')} {/* Remove escape sequences for preview */}
//               </Paper>
//             </CardContent>
//           </Card>

//           <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
//             <Button 
//               variant="outlined" 
//               onClick={handleOpenCashDrawer}
//               disabled={isOpeningDrawer}
//               startIcon={<Receipt />}
//             >
//               {isOpeningDrawer ? "Opening..." : "Test Cash Drawer"}
//             </Button>
//             <Typography variant="body2" color="text.secondary">
//               Printer: {PRINTER_NAME}
//             </Typography>
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={onClose}>Cancel</Button>
//           <Button 
//             onClick={printThermalReceipt} 
//             variant="contained" 
//             color="primary"
//             startIcon={<Print />}
//             disabled={isPrinting}
//           >
//             {isPrinting ? "Printing..." : "Print Thermal Receipt"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar 
//         open={printStatus.open} 
//         autoHideDuration={6000} 
//         onClose={() => setPrintStatus({ ...printStatus, open: false })}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//       >
//         <Alert 
//           severity={printStatus.severity} 
//           onClose={() => setPrintStatus({ ...printStatus, open: false })}
//         >
//           {printStatus.message}
//         </Alert>
//       </Snackbar>
//     </>
//   );
// };

// // Main Invoice Component
// export default function Invoice() {
//   const { patientId, serial_no } = useParams();
//   const [patients, setPatients] = useState(null);
//   const [invoicedetails, setInvoicedetails] = useState(null);
//   const [treatmentamount, setTreatmentamount] = useState(0);
//   const [discount, setDiscount] = useState(0);
//   const [discountType, setDiscountType] = useState("percentage");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [qzTrayDialogOpen, setQzTrayDialogOpen] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         const [treatmentRes, patientRes] = await Promise.all([
//           axios.get(
//             `${process.env.REACT_APP_API_BASE_URL}/Treatment/patient/record/${patientId}/${serial_no}`
//           ),
//           axios.get(
//             `${process.env.REACT_APP_API_BASE_URL}/Patient/${patientId}`
//           ),
//         ]);
//         setInvoicedetails(treatmentRes.data);
//         setTreatmentamount(treatmentRes.data.MTD_AMOUNT || 0);
//         setPatients(patientRes.data);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         setError(error.response?.data?.message || "Failed to fetch data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [patientId, serial_no]);

//   const calculateSubtotal = () => {
//     if (invoicedetails && invoicedetails.Drugs) {
//       const total = invoicedetails.Drugs.reduce(
//         (total, drug) => total + drug.MDD_AMOUNT,
//         0
//       );
//       return total.toFixed(2);
//     }
//     return 0;
//   };

//   const calculateTotalAmount = () => {
//     const subtotal =
//       parseFloat(calculateSubtotal()) + parseFloat(treatmentamount);
//     let totalAmount = subtotal;

//     if (discountType === "percentage") {
//       totalAmount -= (subtotal * discount) / 100;
//     } else {
//       totalAmount -= discount;
//     }

//     return totalAmount.toFixed(2);
//   };

//   const printInvoice = () => {
//     const noPrintElements = document.querySelectorAll('.no-print');
//     noPrintElements.forEach(element => {
//       element.style.display = 'none';
//     });

//     const printStyles = document.createElement('style');
//     printStyles.innerHTML = `
//     @media print {
//       body * {
//         visibility: hidden;
//       }
      
//       #invoice-content, #invoice-content * {
//         visibility: visible;
//       }
      
//       #invoice-content {
//         position: absolute;
//         left: 0;
//         top: 0;
//         width: 100%;
//       }
      
//       .MuiContainer-root {
//         max-width: none !important;
//         padding: 0 !important;
//         margin: 0 !important;
//       }
      
//       .MuiPaper-root {
//         box-shadow: none !important;
//         border: none !important;
//         margin: 0 !important;
//         padding: 20px !important;
//       }
      
//       @page {
//         size: A4;
//         margin: 15mm;
//       }
//     }
//   `;

//     document.head.appendChild(printStyles);
//     window.print();

//     setTimeout(() => {
//       document.head.removeChild(printStyles);
//       noPrintElements.forEach(element => {
//         element.style.display = '';
//       });
//     }, 100);
//   };

//   const downloadInvoice = () => {
//     const element = document.getElementById("invoice-content");
//     const opt = {
//       margin: [10, 10, 10, 10],
//       filename: `invoice_${patientId}_${serial_no}.pdf`,
//       image: {
//         type: "jpeg",
//         quality: 0.98
//       },
//       html2canvas: {
//         scale: 2,
//         logging: false,
//         useCORS: true,
//         allowTaint: true,
//         backgroundColor: '#ffffff',
//         ignoreElements: function (element) {
//           return element.classList.contains('no-print');
//         }
//       },
//       jsPDF: {
//         unit: "mm",
//         format: "a4",
//         orientation: "portrait",
//         putOnlyUsedFonts: true,
//         floatPrecision: 16
//       },
//       pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
//     };
//     const tempStyles = document.createElement('style');
//     tempStyles.innerHTML = `
//       .invoice-number-pdf {
//         backgroundColor: theme.palette.secondary.main;
//         color: white !important;
//         -webkit-print-color-adjust: exact !important;
//         color-adjust: exact !important;
//         print-color-adjust: exact !important;
//       }
//     `;
//     document.head.appendChild(tempStyles);

//     html2pdf().set(opt).from(element).save().then(() => {
//       document.head.removeChild(tempStyles);
//     });
//   };

//   if (loading) {
//     return (
//       <Box
//         display="flex"
//         justifyContent="center"
//         alignItems="center"
//         minHeight="80vh"
//       >
//         <CircularProgress size={60} />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4 }}>
//         <Paper elevation={3} sx={{ p: 3, textAlign: "center" }}>
//           <Typography variant="h6" color="error">
//             {error}
//           </Typography>
//           <Button
//             variant="contained"
//             color="primary"
//             sx={{ mt: 2 }}
//             onClick={() => window.location.reload()}
//           >
//             Retry
//           </Button>
//         </Paper>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="xl" sx={{ py: 4 }}>
//       <Box sx={{ mb: 3 }} className="no-print">
//         <Button
//           startIcon={<ArrowBack />}
//           onClick={() => navigate(-1)}
//           variant="outlined"
//         >
//           Back to Records
//         </Button>
//       </Box>

//       <StyledPaper elevation={3} id="invoice-content">
//         <HeaderBox>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//             <Avatar
//               src={logo}
//               alt="Medicare Logo"
//               variant="rounded"
//               sx={{ width: 80, height: 80, '@media print': { width: 60, height: 60 } }}
//             />
//             <Box>


//               <Typography variant="h5" fontWeight="bold" color="primary" sx={{ '@media print': { fontSize: '2rem' } }}>
//                 AURA MEDITATION
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
//                 No:128/1,Pahala karagahamuna,Kadawatha
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
//                 Tel: 0114532108|0117905805 | Email: akdldhshana@gmail.com
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
//                 Web: www.auracare.lk
//               </Typography>
//             </Box>
//           </Box>

//           <Box sx={{ textAlign: "right" }}>
//             <Typography variant="h5" color="primary" fontWeight="bold" sx={{ '@media print': { fontSize: '1.5rem' } }}>
//               Payment Receipt
//             </Typography>
//             <InvoiceNumberBox className="invoice-number-pdf">
//               Invoice - {invoicedetails?.MTD_SERIAL_NO || "N/A"}
//             </InvoiceNumberBox>
//           </Box>
//         </HeaderBox>

//         <Divider sx={{ my: 3 }} />

//         <Box
//           sx={{
//             display: "flex",
//             flexWrap: "wrap",
//             gap: { xs: 2, sm: 3 },
//             mb: 4,
//             alignItems: "center",
//             justifyContent: "space-between",
//             '& > *': {
//               flex: { xs: '1 1 100%', sm: '1 1 calc(25% - 24px)', md: '1 1 calc(25% - 24px)' },
//               minWidth: { xs: '100%', sm: '200px' },
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//             },
//             '@media print': {
//               gap: 2,
//               marginBottom: '16px',
//               '& > *': {
//                 flex: '1 1 calc(25% - 16px)',
//                 minWidth: 'auto'
//               }
//             }
//           }}
//         >
//           <Box>
//             <Person color="primary" />
//             <Box>
//               <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
//                 Patient Name
//               </Typography>
//               <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
//                 {patients?.MPD_PATIENT_NAME}
//               </Typography>
//             </Box>
//           </Box>

//           <Box>
//             <Home color="primary" />
//             <Box>
//               <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
//                 Address
//               </Typography>
//               <Typography variant="body1" fontWeight="500" sx={{
//                 '@media print': { fontSize: '1rem' },
//                 display: '-webkit-box',
//                 WebkitLineClamp: 1,
//                 WebkitBoxOrient: 'vertical',
//                 overflow: 'hidden'
//               }}>
//                 {patients?.MPD_ADDRESS || "Not specified"}
//               </Typography>
//             </Box>
//           </Box>

//           <Box>
//             <CalendarToday color="primary" />
//             <Box>
//               <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
//                 Date
//               </Typography>
//               <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
//                 {new Date().toLocaleDateString()}
//               </Typography>
//             </Box>
//           </Box>

//           <Box>
//             {patients?.MPD_GENDER === "Male" ? (
//               <Male color="primary" />
//             ) : (
//               <Female color="primary" />
//             )}
//             <Box>
//               <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
//                 Gender / Age
//               </Typography>
//               <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
//                 {patients?.MPD_GENDER} /{" "}
//                 {patients?.MPD_BIRTHDAY
//                   ? new Date().getFullYear() -
//                   new Date(patients.MPD_BIRTHDAY).getFullYear()
//                   : "N/A"}
//               </Typography>
//             </Box>
//           </Box>
//         </Box>

//         <TableContainer
//           component={Paper}
//           elevation={0}
//           sx={{ border: "1px solid #eee", mb: 4 }}
//         >
//           <Table>
//             <TableHead sx={{ backgroundColor: "primary.main" }}>
//               <TableRow>
//                 <TableCell sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}>
//                   Drug Description
//                 </TableCell>
//                 <TableCell
//                   align="right"
//                   sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
//                 >
//                   Rate (Rs)
//                 </TableCell>
//                 <TableCell
//                   align="right"
//                   sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
//                 >
//                   Quantity
//                 </TableCell>
//                 <TableCell
//                   align="right"
//                   sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
//                 >
//                   Amount (Rs)
//                 </TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {invoicedetails?.Drugs?.map((medicinedetail, index) => (
//                 <TableRow key={index} hover>
//                   <TableCell sx={{ '@media print': { fontSize: '0.9rem' } }}>{medicinedetail.DrugName}</TableCell>
//                   <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
//                     {medicinedetail.MDD_RATE
//                       ? new Intl.NumberFormat('en-US', {
//                         minimumFractionDigits: 2,
//                         maximumFractionDigits: 2,
//                       }).format(Number(medicinedetail.MDD_RATE))
//                       : "0.00"}
//                   </TableCell>

//                   <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
//                     {medicinedetail.MDD_QUANTITY
//                       ? new Intl.NumberFormat('en-US').format(Number(medicinedetail.MDD_QUANTITY))
//                       : "0"}
//                   </TableCell>

//                   <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
//                     {medicinedetail.MDD_AMOUNT
//                       ? new Intl.NumberFormat('en-US', {
//                         minimumFractionDigits: 2,
//                         maximumFractionDigits: 2,
//                       }).format(Number(medicinedetail.MDD_AMOUNT))
//                       : "0.00"}
//                   </TableCell>
//                 </TableRow>
//               ))}

//               <TotalRow>
//                 <TableCell colSpan={2}></TableCell>
//                 <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
//                   Total Drug Fee:
//                 </TableCell>
//                 <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
//                   Rs: {new Intl.NumberFormat('en-US', {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2
//                   }).format(Number(calculateSubtotal()))}
//                 </TableCell>
//               </TotalRow>

//               <TotalRow>
//                 <TableCell colSpan={2}></TableCell>
//                 <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
//                   Treatment Fee:
//                 </TableCell>
//                 <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
//                   Rs: {new Intl.NumberFormat('en-US', {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2
//                   }).format(Number(treatmentamount))}
//                 </TableCell>
//               </TotalRow>

//               <TotalRow>
//                 <TableCell colSpan={2}></TableCell>
//                 <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
//                   Subtotal:
//                 </TableCell>
//                 <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
//                   Rs: {new Intl.NumberFormat('en-US', {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2
//                   }).format(
//                     Number(calculateSubtotal()) + Number(treatmentamount)
//                   )}
//                 </TableCell>
//               </TotalRow>

//               <DiscountRow>
//                 <TableCell colSpan={1}></TableCell>
//                 <TableCell>
//                   <Typography fontWeight="bold" sx={{ '@media print': { fontSize: '1rem' } }}>Discount</Typography>
//                   <RadioGroup
//                     row
//                     value={discountType}
//                     onChange={(e) => setDiscountType(e.target.value)}
//                     sx={{ mt: 1 }}
//                   >
//                     <FormControlLabel
//                       value="percentage"
//                       control={<Radio size="small" />}
//                       label={<Typography sx={{ '@media print': { fontSize: '0.9rem' } }}>Percentage</Typography>}
//                     />
//                     <FormControlLabel
//                       value="fixed"
//                       control={<Radio size="small" />}
//                       label={<Typography sx={{ '@media print': { fontSize: '0.9rem' } }}>Fixed Amount</Typography>}
//                     />
//                   </RadioGroup>
//                 </TableCell>
//                 <TableCell align="right">
//                   <TextField
//                     type="number"
//                     size="small"
//                     value={discount}
//                     onChange={(e) => setDiscount(e.target.value)}
//                     inputProps={{
//                       min: "0",
//                       max:
//                         discountType === "percentage"
//                           ? "100"
//                           : parseFloat(calculateSubtotal()) +
//                           parseFloat(treatmentamount),
//                     }}
//                     sx={{ width: 120 }}
//                   />
//                 </TableCell>
//                 <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
//                   {discountType === "percentage"
//                     ? `${discount}%`
//                     : `Rs: ${discount}`}
//                 </TableCell>
//               </DiscountRow>

//               <TotalRow sx={{ backgroundColor: "primary.light" }}>
//                 <TableCell colSpan={2}></TableCell>
//                 <TableCell align="right" sx={{ color: "common.white", '@media print': { fontSize: '1.1rem' } }}>
//                   <Typography variant="h6">Final Amount:</Typography>
//                 </TableCell>
//                 <TableCell
//                   align="right"
//                   sx={{ color: "common.white", '@media print': { fontSize: '1.1rem' } }}
//                 >
//                   <Typography variant="h6">
//                     Rs: {new Intl.NumberFormat('en-US', {
//                       minimumFractionDigits: 2,
//                       maximumFractionDigits: 2
//                     }).format(Number(calculateTotalAmount()))}
//                   </Typography>
//                 </TableCell>
//               </TotalRow>
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Box
//           sx={{
//             mt: 6,
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "flex-end",
//           }}
//         >
//           <Box
//             sx={{
//               width: 300,
//               textAlign: "center",
//               p: 2,
//             }}
//           >
//             <Divider sx={{ mb: 2 }} />
//             <Typography variant="body1" color="text.secondary" sx={{ '@media print': { fontSize: '0.9rem' } }}>
//               Authorized Signature
//             </Typography>
//             <Typography variant="h6" fontWeight="bold" sx={{ mt: 2, '@media print': { fontSize: '1.1rem' } }}>
//               Aura Meditation
//             </Typography>
//           </Box>
//         </Box>
//       </StyledPaper>

//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           gap: 3,
//           mt: 4,
//           "@media print": {
//             display: "none",
//           },
//         }}
//         className="no-print"
//       >
//         <Tooltip title="Print standard invoice">
//           <Button
//             variant="contained"
//             color="primary"
//             startIcon={<Print />}
//             onClick={printInvoice}
//             sx={{ px: 4, py: 1.5 }}
//           >
//             Print Invoice
//           </Button>
//         </Tooltip>

//         <Tooltip title="Print thermal receipt via QZ Tray">
//           <Button
//             variant="contained"
//             color="secondary"
//             startIcon={<ReceiptLong />}
//             onClick={() => setQzTrayDialogOpen(true)}
//             sx={{ px: 4, py: 1.5 }}
//           >
//             QZ Tray Print
//           </Button>
//         </Tooltip>

//         <Tooltip title="Download as PDF">
//           <Button
//             variant="outlined"
//             color="primary"
//             startIcon={<Download />}
//             onClick={downloadInvoice}
//             sx={{ px: 4, py: 1.5 }}
//           >
//             Download PDF
//           </Button>
//         </Tooltip>
//       </Box>

//       {/* QZ Tray Thermal Printing Dialog */}
//       <QZTrayThermalPrint
//         open={qzTrayDialogOpen}
//         onClose={() => setQzTrayDialogOpen(false)}
//         patients={patients}
//         invoicedetails={invoicedetails}
//         treatmentamount={treatmentamount}
//         discount={discount}
//         discountType={discountType}
//         calculateSubtotal={calculateSubtotal}
//         calculateTotalAmount={calculateTotalAmount}
//       />
//     </Container>
//   );
// }


//test//

// import React, { useEffect, useState, useRef } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import {
//   Container,
//   Box,
//   Typography,
//   Paper,
//   Divider,
//   Button,
//   Avatar,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Radio,
//   RadioGroup,
//   FormControlLabel,
//   TextField,
//   Grid,
//   Tooltip,
//   CircularProgress,
//   Chip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Card,
//   CardContent,
//   Alert,
//   Snackbar,
//   FormControl,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import {
//   ArrowBack,
//   Print,
//   Download,
//   LocalHospital,
//   Person,
//   Receipt,
//   Phone,
//   Email,
//   Language,
//   Home,
//   CalendarToday,
//   Male,
//   Female,
//   ReceiptLong,
//   ContentCopy,
//   CloudUpload,
//   Usb,
//   AutoAwesome,
// } from "@mui/icons-material";
// import { styled } from "@mui/material/styles";
// import logo from "../assets/AuraLogo.png";
// import html2pdf from "html2pdf.js";
// import { NumericFormat } from 'react-number-format';
// import auraBmpLogo from "../assets/AuraLogo.bmp";

// // Enhanced Thermal Print Component with BMP Logo Support (Same as first component)
// const ThermalPrintDialog = ({ 
//   open, 
//   onClose, 
//   patients, 
//   invoicedetails, 
//   treatmentamount, 
//   discount, 
//   discountType, 
//   calculateSubtotal, 
//   calculateTotalAmount 
// }) => {
//   const [isPrinting, setIsPrinting] = useState(false);
//   const [printMethod, setPrintMethod] = useState('browser');
//   const [status, setStatus] = useState('');

//   // Use the directly imported BMP logo
//   const logoSource = auraBmpLogo;

//   // Safe patient name display
//   const getPatientName = () => {
//     if (!patients) return 'N/A';
//     return patients?.MPD_PATIENT_NAME || 'Unknown Patient';
//   };

//   const getInvoiceNumber = () => {
//     if (!invoicedetails) return 'N/A';
//     return invoicedetails?.MTD_SERIAL_NO || 'N/A';
//   };

//   const formatCurrency = (value) => {
//     return new Intl.NumberFormat('en-US', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(Number(value));
//   };

//   const calculateFinalSubtotal = () => {
//     return Number(calculateSubtotal()) + Number(treatmentamount);
//   };

//   const calculateFinalTotal = () => {
//     return Number(calculateTotalAmount());
//   };

//   // Generate ESC/POS commands for thermal printers
//   const generateEscPosCommands = () => {
//     const subtotal = calculateFinalSubtotal();
//     const totalAmount = calculateFinalTotal();
    
//     const currentDate = new Date().toLocaleDateString('en-LK');
//     const currentTime = new Date().toLocaleTimeString('en-LK', { 
//       hour: '2-digit', 
//       minute: '2-digit',
//       hour12: false 
//     });

//     // ESC/POS commands
//     const commands = [
//       '\x1B\x40', // Initialize printer
//       '\x1B\x61\x01', // Center alignment
//       '\x1B\x21\x30', // Double height and width
//       'AURA MEDITATION CENTER\n',
//       '\x1B\x21\x00', // Normal text
//       '\x1B\x61\x00', // Left alignment
//       '================================\n',
//       '\x1B\x61\x01', // Center alignment
//       '\x1B\x45\x01', // Bold on
//       'PAYMENT RECEIPT\n',
//       '\x1B\x45\x00', // Bold off
//       '================================\n',
//       '\x1B\x61\x00', // Left alignment
//       '\x1B\x45\x01', // Bold on - DARKER TEXT
//       `Invoice: ${getInvoiceNumber()}\n`,
//       `Date: ${currentDate}\n`,
//       `Time: ${currentTime}\n`,
//       '\x1B\x45\x00', // Bold off
//       '--------------------------------\n',
//       '\x1B\x61\x01', // Center alignment
//       '\x1B\x45\x01', // Bold on - DARKER TEXT
//       'PATIENT DETAILS\n',
//       '\x1B\x45\x00', // Bold off
//       '--------------------------------\n',
//       '\x1B\x61\x00', // Left alignment
//       '\x1B\x45\x01', // Bold on - DARKER TEXT
//       `Name: ${getPatientName()}\n`,
//       `Address: ${(patients?.MPD_ADDRESS || 'Not specified').substring(0, 30)}\n`,
      
//       '\x1B\x45\x00', // Bold off
//       '--------------------------------\n',
//       '\x1B\x61\x01', // Center alignment
//       '\x1B\x45\x01', // Bold on - DARKER TEXT
//       'BILLING DETAILS\n',
//       '\x1B\x45\x00', // Bold off
//       '--------------------------------\n',
//       '\x1B\x61\x00', // Left alignment
//       '\x1B\x45\x01', // Bold on - DARKER TEXT
//       'Item                Qty  Price   Amount\n',
//       '\x1B\x45\x00', // Bold off
//       '--------------------------------\n',
//     ];

//     // Add medicine items with BOLD text
//     if (invoicedetails?.Drugs && invoicedetails.Drugs.length > 0) {
//       invoicedetails.Drugs.forEach(medicinedetail => {
//         const medicineName = medicinedetail.MDD_MATERIAL_NAME || medicinedetail.DrugName || '';
//         const qty = (medicinedetail.MDD_QUANTITY || 0).toString().padStart(2);
//         const rate = formatCurrency(medicinedetail.MDD_RATE || 0).padStart(6);
//         const amount = formatCurrency(medicinedetail.MDD_AMOUNT || 0).padStart(8);
        
//        commands.push(
//         '\x1B\x45\x01',
//         `${medicineName}\n`,
//         `                    ${qty}  ${rate} ${amount}\n`,
//         '\x1B\x45\x00'
//       );
//       });
//     } else {
//       commands.push(
//         '\x1B\x45\x01', // Bold on
//         'No medications\n',
//         '\x1B\x45\x00' // Bold off
//       );
//     }

//     // Add totals with BOLD and LARGER text
//     commands.push(
//       '--------------------------------\n',
//       ...(invoicedetails?.Drugs?.length > 0 ? [
//         '\x1B\x45\x01', // Bold on
//         `Service Charge 1:    Rs. ${formatCurrency(calculateSubtotal())}\n`,
//         '\x1B\x45\x00' // Bold off
//       ] : []),
//       '\x1B\x45\x01', // Bold on
//       `Service Charge 2:    Rs. ${formatCurrency(treatmentamount)}\n`,
     
//       '\x1B\x45\x00', // Bold off
//       ...(discount > 0 ? [
//         '\x1B\x45\x01', // Bold on
//         `Discount:           ${
//           discountType === 'percentage' ? 
//           `-${discount}%` : 
//           `-Rs. ${formatCurrency(discount)}`
//         }\n`,
//         '\x1B\x45\x00' // Bold off
//       ] : []),
//       '================================\n',
//       '\x1B\x21\x30', // Double height and width
//       '\x1B\x45\x01', // Bold on - EXTRA DARK AND LARGE
//       `TOTAL: Rs. ${formatCurrency(totalAmount)}\n`,
//       '\x1B\x45\x00', // Bold off
//       '\x1B\x21\x00', // Normal text
//       '================================\n',
//       '\n',
//       '\x1B\x61\x01', // Center alignment
//       '\x1B\x45\x01', // Bold on
//       'THANK YOU!\n',
//       'Aura Meditation Center\n',
//       '\x1B\x45\x00', // Bold off
//       '--------------------------------\n',
//       '\x1B\x45\x01', // Bold on
//       `${new Date().toLocaleString('en-LK')}\n`,
//       '\x1B\x45\x00', // Bold off
//       '\n\n\n\n',
//       '\x1D\x56\x41\x03' // Cut paper
//     );

//     return commands.join('');
//   };

//   // Method 1: Browser Print with BMP Logo and Thermal Printer CSS
//   const handleBrowserPrint = () => {
//     setIsPrinting(true);
//     setStatus('Preparing print with BMP logo...');

//     const subtotal = calculateFinalSubtotal();
//     const totalAmount = calculateFinalTotal();

//     const printContent = `
//       <!DOCTYPE html>
//       <html>
//       <head>
//         <title>Payment Receipt - Aura Meditation Center</title>
//         <style>
//           @media print {
//             @page {
//               margin: 0;
//               size: 80mm 150mm;
//               margin: 2mm;
//             }
            
//             body {
//               margin: 0;
//               padding: 2mm;
//               font-family: 'Courier New', monospace;
//               font-size: 12px; /* INCREASED FROM 10px */
//               line-height: 1.3; /* INCREASED FROM 1.2 */
//               width: 76mm;
//               background: white;
//               color: #000000; /* PURE BLACK FOR DARKER TEXT */
//               -webkit-print-color-adjust: exact;
//               print-color-adjust: exact;
//               font-weight: 600; /* BOLDER TEXT */
//             }
            
//             .receipt {
//               width: 76mm;
//               margin: 0 auto;
//             }
            
//             .header {
//               text-align: center;
//               margin-bottom: 4px; /* INCREASED */
//             }
            
//             .center {
//               text-align: center;
//             }
            
//             .bold {
//               font-weight: 800; /* BOLDER */
//               color: #000000; /* PURE BLACK */
//             }
            
//             .large {
//               font-size: 16px; /* INCREASED FROM 14px */
//               font-weight: 800; /* BOLDER */
//               color: #000000;
//             }
            
//             .x-large {
//               font-size: 18px; /* INCREASED FROM 16px */
//               font-weight: 900; /* BOLDER */
//               color: #000000;
//             }
            
//             .divider {
//               border-bottom: 2px solid #000;
//               margin: 4px 0; /* INCREASED */
//               height: 2px;
//             }
            
//             .double-divider {
//               border-bottom: 3px solid #000;
//               margin: 5px 0; /* INCREASED */
//               height: 3px;
//             }
            
//             .text-left {
//               text-align: left;
//             }
            
//             .text-right {
//               text-align: right;
//             }
            
//             .row {
//               display: flex;
//               justify-content: space-between;
//               margin: 3px 0; /* INCREASED */            
//               font-weight: 700; /* BOLDER */
//               color: #000000;
//             }

//             .footer {
//               text-align: center;
//               margin-top: 12px; /* INCREASED */
//               font-weight: 800; /* BOLDER */
//               color: #000000;
//             }
            
//             .logo {
//               text-align: center;
//               margin-bottom: 6px; /* INCREASED */
//             }
            
//             .timestamp {
//               text-align: center;
//               font-weight: 800; /* BOLDER */
//               color: #000000 !important;
//               -webkit-print-color-adjust: exact;
//               print-color-adjust: exact;
//               margin-top: 6px; /* INCREASED */
//               font-size: 11px; /* INCREASED FROM 9px */
//             }
            
//             /* Enhanced BMP logo styling - UNCHANGED */
//             .bmp-logo {
//               max-width: 35mm;
//               height: auto;
//               display: block;
//               margin: 0 auto 3px auto;
//               filter: invert(1) brightness(2) contrast(1000%) saturate(0%);
//               -webkit-filter: invert(1) brightness(2) contrast(1000%) saturate(0%);
//               image-rendering: pixelated;
//               image-rendering: -webkit-optimize-contrast;
//             }
            
//             .items-table {
//               width: 100%;
//               border-collapse: collapse;
//               font-weight: 700; /* BOLDER TABLE TEXT */
//               color: #000000;
//             }
            
//             .items-table td {
//               padding: 2px 0; /* INCREASED */
              
//               font-size: 11px; /* INCREASED */
//             }
            
//             .total-row {
//               font-weight: 900; /* BOLDER */
//               border-top: 2px solid #000;
//               font-size: 13px; /* LARGER */
//               color: #000000;
//             }

//             .section-title {
//               font-weight: 900; /* BOLDER */
//               font-size: 13px; /* LARGER */
//               color: #000000;
//               text-align: center;
//               margin: 4px 0;
//             }

//             .important-text {
//               font-weight: 800; /* BOLDER */
//               color: #000000;
//               font-size: 12px; /* LARGER */
//             }

//             .patient-details {
//               font-weight: 700; /* BOLDER */
//               color: #000000;
//               font-size: 11px; /* LARGER */
//             }
//           }
          
//           @media screen {
//             body {
//               background: #f5f5f5;
//               padding: 20px;
//             }
//             .receipt {
//               border: 2px dashed #666;
//               background: white;
//               padding: 10px;
//             }
//           }
//         </style>
//       </head>
//       <body>
//         <div class="receipt">
//           <!-- BMP Logo Section - UNCHANGED -->
//           <div class="logo">
//             <img src="${logoSource}" alt="Aura Meditation Center" class="bmp-logo">
//           </div>
          
//           <div class="header">
//             <div class="x-large">AURA MEDITATION CENTER</div>
//             <div class="double-divider"></div>
//             <div class="large">PAYMENT RECEIPT</div>
//             <div class="double-divider"></div>
//           </div>
          
//           <!-- Invoice Info -->
//           <div class="text-left important-text">
//             <div class="row">
//               <span>Invoice:</span>
//               <span>${getInvoiceNumber()}</span>
//             </div>
//             <div class="row">
//               <span>Date:</span>
//               <span>${new Date().toLocaleDateString('en-LK')}</span>
//             </div>
//             <div class="row">
//               <span>Time:</span>
//               <span>${new Date().toLocaleTimeString('en-LK', { hour: '2-digit', minute: '2-digit', hour12: false })}</span>
//             </div>
//           </div>
          
//           <div class="divider"></div>
          
//           <!-- Patient Details -->
//           <div class="section-title">PATIENT DETAILS</div>
//           <div class="divider"></div>
          
//           <div class="text-left patient-details">
//             <div class="row">
//               <span>Name:</span>
//               <span>${getPatientName()}</span>
//             </div>
//             <div class="row">
//               <span>Address:</span>
//               <span>${(patients?.MPD_ADDRESS || 'Not specified').substring(0, 30)}</span>
//             </div>
           
//           </div>
          
//           <div class="divider"></div>
          
//           <!-- Billing Details -->
//           <div class="section-title">BILLING DETAILS</div>
//           <div class="divider"></div>
          
//           <table class="items-table">
//             <tr class="bold">
//               <td class="text-left">Item</td>
//               <td class="text-right">Qty</td>
//               <td class="text-right">Price</td>
//               <td class="text-right">Amount</td>
//             </tr>
//             ${invoicedetails?.Drugs?.map(medicinedetail => `
//               <tr class="important-text">
//                 <td class="text-left">${medicinedetail.MDD_MATERIAL_NAME  || medicinedetail.DrugName || ''}</td>
//                 <td class="text-right">${medicinedetail.MDD_QUANTITY || 0}</td>
//                 <td class="text-right">${formatCurrency(medicinedetail.MDD_RATE || 0)}</td>
//                 <td class="text-right">${formatCurrency(medicinedetail.MDD_AMOUNT || 0)}</td>
//               </tr>
//             `).join('') || '<tr><td colspan="4" class="text-center important-text">No medications</td></tr>'}
//           </table>
          
//           <div class="divider"></div>
          
//           <!-- Totals -->
//           <div class="text-left important-text">
//             ${invoicedetails?.Drugs?.length > 0 ? `
//             <div class="row">
//               <span>Service Charge 1:</span>
//               <span>Rs. ${formatCurrency(calculateSubtotal())}</span>
//             </div>
//             ` : ''}
//             <div class="row">
//               <span>Service Charge 2:</span>
//               <span>Rs. ${formatCurrency(treatmentamount)}</span>
//             </div>
            
//             ${discount > 0 ? `
//             <div class="row">
//               <span>Discount:</span>
//               <span>${discountType === 'percentage' ? `-${discount}%` : `-Rs. ${formatCurrency(discount)}`}</span>
//             </div>
//             ` : ''}
//             <div class="row total-row">
//               <span>TOTAL:</span>
//               <span>Rs. ${formatCurrency(totalAmount)}</span>
//             </div>
//           </div>
          
//           <div class="divider"></div>
          
//           <div class="footer">
//             <div class="bold">THANK YOU!</div>
//             <div class="bold">Aura Meditation Center</div>
//           </div>
          
//           <div class="timestamp">
//             <strong>Generated: ${new Date().toLocaleString('en-LK')}</strong>
//           </div>
//         </div>
        
//         <script>
//           window.onload = function() {
//             setTimeout(function() {
//               window.print();
//               setTimeout(function() {
//                 window.close();
//               }, 500);
//             }, 500);
//           };
//         </script>
//       </body>
//       </html>
//     `;

//     const printWindow = window.open('', '_blank', 'width=400,height=600');
//     if (printWindow) {
//       printWindow.document.write(printContent);
//       printWindow.document.close();
//       setStatus('Print dialog opened with BMP logo');
//     } else {
//       setStatus('Failed to open print window. Please allow popups.');
//     }
    
//     setTimeout(() => {
//       setIsPrinting(false);
//       onClose();
//     }, 2000);
//   };

//   // Method 2: Download ESC/POS file for manual transfer
//   const handleDownloadEscPos = () => {
//     setIsPrinting(true);
//     setStatus('Generating ESC/POS file...');
    
//     try {
//       const escPosData = generateEscPosCommands();
      
//       const blob = new Blob([escPosData], { type: 'application/octet-stream' });
//       const url = URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = `payment-receipt-${getInvoiceNumber()}.txt`;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//       URL.revokeObjectURL(url);
      
//       setStatus('ESC/POS file downloaded. Transfer to printer manually.');
//       setTimeout(() => {
//         setIsPrinting(false);
//         onClose();
//       }, 2000);
//     } catch (error) {
//       setStatus('Error generating file: ' + error.message);
//       setIsPrinting(false);
//     }
//   };

//   // Method 3: Server-side printing
//   const handleServerPrint = async () => {
//     setIsPrinting(true);
//     setStatus('Sending to server printer...');
    
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/print/payment-receipt`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ 
//           patients,
//           invoicedetails,
//           treatmentamount,
//           discount,
//           discountType,
//           subtotal: calculateSubtotal(),
//           totalAmount: calculateTotalAmount(),
//           type: 'thermal',
//           timestamp: new Date().toISOString()
//         }),
//       });
      
//       if (response.ok) {
//         const result = await response.json();
//         setStatus('Print job sent to server successfully!');
//         setTimeout(() => {
//           setIsPrinting(false);
//           onClose();
//         }, 1500);
//       } else {
//         throw new Error('Server returned error: ' + response.status);
//       }
//     } catch (error) {
//       setStatus('Server printing failed: ' + error.message);
//       setTimeout(() => {
//         setStatus('Falling back to browser print...');
//         handleBrowserPrint();
//       }, 1500);
//     }
//   };

//   const handlePrint = () => {
//     switch (printMethod) {
//       case 'browser':
//         handleBrowserPrint();
//         break;
//       case 'server':
//         handleServerPrint();
//         break;
//       case 'download':
//         handleDownloadEscPos();
//         break;
//       default:
//         handleBrowserPrint();
//     }
//   };

//   const printMethods = [
//     {
//       id: 'browser',
//       name: 'Browser Thermal Print',
//       description: 'Optimized for thermal printers with BMP logo',
//       icon: <Print />,
//     },
//     {
//       id: 'download',
//       name: 'Download ESC/POS File',
//       description: 'Download file for manual transfer to thermal printer',
//       icon: <Download />,
//     },
//     {
//       id: 'server',
//       name: 'Server Print',
//       description: 'Send to network/shared printer',
//       icon: <CloudUpload />,
//     }
//   ];

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
//       <DialogTitle>
//         Print Payment Receipt
//         <Chip label="BMP Logo" color="success" size="small" sx={{ ml: 1 }} />
//       </DialogTitle>
//       <DialogContent>
//         <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
//           Select printing method for thermal receipt with BMP logo support
//         </Typography>
        
//         <FormControl fullWidth sx={{ mb: 3 }}>
//           <Select
//             value={printMethod}
//             onChange={(e) => setPrintMethod(e.target.value)}
//             disabled={isPrinting}
//           >
//             {printMethods.map(method => (
//               <MenuItem key={method.id} value={method.id}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                   {method.icon}
//                   <Box>
//                     <Typography variant="body2" fontWeight="bold">
//                       {method.name}
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       {method.description}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>

//         {/* Enhanced Print Preview with BMP Logo */}
//         <Card variant="outlined" sx={{ mb: 2 }}>
//           <CardContent>
//             <Typography variant="h6" gutterBottom>
//               Receipt Preview with BMP Logo
//             </Typography>
//             <Paper 
//               sx={{ 
//                 p: 2, 
//                 backgroundColor: '#f5f5f5', 
//                 fontFamily: 'Courier New, monospace', 
//                 fontSize: '12px', // INCREASED FROM 10px
//                 lineHeight: '1.3', // INCREASED
//                 border: '1px dashed #ccc',
//                 fontWeight: '600', // BOLDER
//                 color: '#000000' // DARKER
//               }}
//             >
//               {/* BMP Logo Preview - UNCHANGED */}
//               <Box sx={{ textAlign: 'center', mb: 1 }}>
//                 <img 
//                   src={logoSource} 
//                   alt="Aura Logo" 
//                   style={{ 
//                     maxWidth: '35mm', 
//                     height: 'auto',
//                     filter: 'invert(1) brightness(2) contrast(1000%) saturate(0%)'
//                   }}
//                 />
//               </Box>
              
//               <div style={{ textAlign: 'center', fontWeight: '900', fontSize: '14px', color: '#000000' }}>
//                 AURA MEDITATION CENTER
//               </div>
//               <div style={{ borderBottom: '2px solid #000', margin: '4px 0' }}></div>
//               <div style={{ textAlign: 'center', fontWeight: '800', color: '#000000' }}>PAYMENT RECEIPT</div>
//               <div style={{ borderBottom: '2px solid #000', margin: '4px 0' }}></div>
              
//               {/* Invoice Info */}
//               <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '700', color: '#000000' }}>
//                 <span>Invoice:</span>
//                 <span>${getInvoiceNumber()}</span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '700', color: '#000000' }}>
//                 <span>Date:</span>
//                 <span>${new Date().toLocaleDateString('en-LK')}</span>
//               </div>
              
//               <div style={{ borderBottom: '2px solid #000', margin: '4px 0' }}></div>
//               <div style={{ textAlign: 'center', fontWeight: '900', color: '#000000', fontSize: '13px' }}>PATIENT DETAILS</div>
//               <div style={{ borderBottom: '2px solid #000', margin: '4px 0' }}></div>
              
//               {/* Patient Details */}
//               <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '700', color: '#000000' }}>
//                 <span>Name:</span>
//                 <span>${getPatientName()}</span>
//               </div>
              
//               <div style={{ borderBottom: '2px solid #000', margin: '4px 0' }}></div>
//               <div style={{ textAlign: 'center', fontWeight: '900', color: '#000000', fontSize: '13px' }}>BILLING DETAILS</div>
//               <div style={{ borderBottom: '2px solid #000', margin: '4px 0' }}></div>
              
//               {/* Totals Preview */}
//               <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '700', color: '#000000' }}>
//                 <span>Service Charge 1:</span>
//                 <span>Rs. ${formatCurrency(calculateSubtotal())}</span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '700', color: '#000000' }}>
//                 <span>Service Charge 2:</span>
//                 <span>Rs. ${formatCurrency(treatmentamount)}</span>
//               </div>
//               <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '900', color: '#000000', fontSize: '13px' }}>
//                 <span>TOTAL:</span>
//                 <span>Rs. ${formatCurrency(calculateTotalAmount())}</span>
//               </div>
              
//               <div style={{ borderBottom: '2px solid #000', margin: '4px 0' }}></div>
//               <div style={{ textAlign: 'center', fontWeight: '800', color: '#000000' }}>
//                 THANK YOU!<br/>Aura Meditation Center
//               </div>
              
//               {/* Timestamp */}
//               <div style={{ textAlign: 'center', marginTop: '8px', fontWeight: '800', color: '#000000', fontSize: '11px' }}>
//                 Generated: ${new Date().toLocaleString('en-LK')}
//               </div>
//             </Paper>
//           </CardContent>
//         </Card>

//         {status && (
//           <Alert severity="info" sx={{ mb: 2 }}>
//             {status}
//           </Alert>
//         )}
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose} disabled={isPrinting}>
//           Cancel
//         </Button>
//         <Button 
//           onClick={handlePrint}
//           variant="contained"
//           disabled={isPrinting}
//           startIcon={isPrinting ? <CircularProgress size={16} /> : <Print />}
//         >
//           {isPrinting ? 'Printing...' : 'Print Receipt'}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };


// // ... (keep all the existing styled components and main Invoice component exactly as they were)

// // Styled Components (keep your existing styled components)
// const StyledPaper = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(4),
//   marginTop: theme.spacing(3),
//   borderRadius: theme.shape.borderRadius * 2,
//   boxShadow: theme.shadows[3],
//   maxWidth: 1500,
//   margin: "0 auto",
//   "@media print": {
//     boxShadow: "none",
//     padding: theme.spacing(3),
//     border: "1px solid #ddd",
//   },
// }));

// const HeaderBox = styled(Box)(({ theme }) => ({
//   display: "flex",
//   justifyContent: "space-between",
//   alignItems: "center",
//   marginBottom: theme.spacing(4),
//   "@media (max-width: 600px)": {
//     flexDirection: "column",
//     gap: theme.spacing(2),
//     alignItems: "flex-start",
//   },
//   "@media print": {
//     flexDirection: "row",
//     alignItems: "center",
//   },
// }));

// const TotalRow = styled(TableRow)(({ theme }) => ({
//   backgroundColor: theme.palette.grey[100],
//   "& td": {
//     fontWeight: "bold",
//     fontSize: "1.1rem",
//   },
// }));

// const DiscountRow = styled(TableRow)(({ theme }) => ({
//   backgroundColor: theme.palette.grey[50],
//   "& td": {
//     padding: theme.spacing(2),
//   },
// }));

// const InvoiceNumberBox = styled(Box)(({ theme }) => ({
//   backgroundColor: theme.palette.secondary.main,
//   color: 'white',
//   padding: '6px 12px',
//   borderRadius: '16px',
//   display: 'inline-block',
//   marginTop: theme.spacing(1),
//   fontSize: '0.875rem',
//   fontWeight: 500,
//   '-webkit-print-color-adjust': 'exact',
//   'color-adjust': 'exact',
//   'print-color-adjust': 'exact',
// }));

// // Main Invoice Component (keep exactly as it was, only the ThermalPrintDialog is updated)
// export default function Invoice() {
//   const { patientId, serial_no } = useParams();
//   const [patients, setPatients] = useState(null);
//   const [invoicedetails, setInvoicedetails] = useState(null);
//   const [treatmentamount, setTreatmentamount] = useState(0);
//   const [discount, setDiscount] = useState(0);
//   const [discountType, setDiscountType] = useState("percentage");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [thermalPrintDialogOpen, setThermalPrintDialogOpen] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         const [treatmentRes, patientRes] = await Promise.all([
//           axios.get(
//             `${process.env.REACT_APP_API_BASE_URL}/Treatment/patient/record/${patientId}/${serial_no}`
//           ),
//           axios.get(
//             `${process.env.REACT_APP_API_BASE_URL}/Patient/${patientId}`
//           ),
//         ]);
//         setInvoicedetails(treatmentRes.data);
//         setTreatmentamount(treatmentRes.data.MTD_AMOUNT || 0);
//         setPatients(patientRes.data);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         setError(error.response?.data?.message || "Failed to fetch data");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [patientId, serial_no]);

//   const calculateSubtotal = () => {
//     if (invoicedetails && invoicedetails.Drugs) {
//       const total = invoicedetails.Drugs.reduce(
//         (total, drug) => total + drug.MDD_AMOUNT,
//         0
//       );
//       return total.toFixed(2);
//     }
//     return 0;
//   };

//   const calculateTotalAmount = () => {
//     const subtotal =
//       parseFloat(calculateSubtotal()) + parseFloat(treatmentamount);
//     let totalAmount = subtotal;

//     if (discountType === "percentage") {
//       totalAmount -= (subtotal * discount) / 100;
//     } else {
//       totalAmount -= discount;
//     }

//     return totalAmount.toFixed(2);
//   };

//   const printInvoice = () => {
//     const noPrintElements = document.querySelectorAll('.no-print');
//     noPrintElements.forEach(element => {
//       element.style.display = 'none';
//     });

//     const printStyles = document.createElement('style');
//     printStyles.innerHTML = `
//     @media print {
//       body * {
//         visibility: hidden;
//       }
      
//       #invoice-content, #invoice-content * {
//         visibility: visible;
//       }
      
//       #invoice-content {
//         position: absolute;
//         left: 0;
//         top: 0;
//         width: 100%;
//       }
      
//       .MuiContainer-root {
//         max-width: none !important;
//         padding: 0 !important;
//         margin: 0 !important;
//       }
      
//       .MuiPaper-root {
//         box-shadow: none !important;
//         border: none !important;
//         margin: 0 !important;
//         padding: 20px !important;
//       }
      
//       @page {
//         size: A4;
//         margin: 15mm;
//       }
//     }
//   `;

//     document.head.appendChild(printStyles);
//     window.print();

//     setTimeout(() => {
//       document.head.removeChild(printStyles);
//       noPrintElements.forEach(element => {
//         element.style.display = '';
//       });
//     }, 100);
//   };

//   const downloadInvoice = () => {
//     const element = document.getElementById("invoice-content");
//     const opt = {
//       margin: [10, 10, 10, 10],
//       filename: `invoice_${patientId}_${serial_no}.pdf`,
//       image: {
//         type: "jpeg",
//         quality: 0.98
//       },
//       html2canvas: {
//         scale: 2,
//         logging: false,
//         useCORS: true,
//         allowTaint: true,
//         backgroundColor: '#ffffff',
//         ignoreElements: function (element) {
//           return element.classList.contains('no-print');
//         }
//       },
//       jsPDF: {
//         unit: "mm",
//         format: "a4",
//         orientation: "portrait",
//         putOnlyUsedFonts: true,
//         floatPrecision: 16
//       },
//       pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
//     };
//     const tempStyles = document.createElement('style');
//     tempStyles.innerHTML = `
//       .invoice-number-pdf {
//         backgroundColor: theme.palette.secondary.main;
//         color: white !important;
//         -webkit-print-color-adjust: exact !important;
//         color-adjust: exact !important;
//         print-color-adjust: exact !important;
//       }
//     `;
//     document.head.appendChild(tempStyles);

//     html2pdf().set(opt).from(element).save().then(() => {
//       document.head.removeChild(tempStyles);
//     });
//   };

//   if (loading) {
//     return (
//       <Box
//         display="flex"
//         justifyContent="center"
//         alignItems="center"
//         minHeight="80vh"
//       >
//         <CircularProgress size={60} />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Container maxWidth="md" sx={{ mt: 4 }}>
//         <Paper elevation={3} sx={{ p: 3, textAlign: "center" }}>
//           <Typography variant="h6" color="error">
//             {error}
//           </Typography>
//           <Button
//             variant="contained"
//             color="primary"
//             sx={{ mt: 2 }}
//             onClick={() => window.location.reload()}
//           >
//             Retry
//           </Button>
//         </Paper>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="xl" sx={{ py: 4 }}>
//       <Box sx={{ mb: 3 }} className="no-print">
//         <Button
//           startIcon={<ArrowBack />}
//           onClick={() => navigate(-1)}
//           variant="outlined"
//         >
//           Back to Records
//         </Button>
//       </Box>

//       <StyledPaper elevation={3} id="invoice-content">
//         {/* ... (keep the rest of your existing invoice JSX exactly as it was) */}
//         <HeaderBox>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//             <Avatar
//               src={logo}
//               alt="Medicare Logo"
//               variant="rounded"
//               sx={{ width: 80, height: 80, '@media print': { width: 60, height: 60 } }}
//             />
//             <Box>
//               <Typography variant="h5" fontWeight="bold" color="primary" sx={{ '@media print': { fontSize: '2rem' } }}>
//                 AURA MEDITATION
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
//                 No:128/1,Pahala karagahamuna,Kadawatha
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
//                 Tel: 0114532108|0117905805 | Email: akdldhshana@gmail.com
//               </Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
//                 Web: www.auracare.lk
//               </Typography>
//             </Box>
//           </Box>

//           <Box sx={{ textAlign: "right" }}>
//             <Typography variant="h5" color="primary" fontWeight="bold" sx={{ '@media print': { fontSize: '1.5rem' } }}>
//               Payment Receipt
//             </Typography>
//             <InvoiceNumberBox className="invoice-number-pdf">
//               Invoice - {invoicedetails?.MTD_SERIAL_NO || "N/A"}
//             </InvoiceNumberBox>
//           </Box>
//         </HeaderBox>

//         <Divider sx={{ my: 3 }} />

//         <Box
//           sx={{
//             display: "flex",
//             flexWrap: "wrap",
//             gap: { xs: 2, sm: 3 },
//             mb: 4,
//             alignItems: "center",
//             justifyContent: "space-between",
//             '& > *': {
//               flex: { xs: '1 1 100%', sm: '1 1 calc(25% - 24px)', md: '1 1 calc(25% - 24px)' },
//               minWidth: { xs: '100%', sm: '200px' },
//               display: "flex",
//               alignItems: "center",
//               gap: 1,
//             },
//             '@media print': {
//               gap: 2,
//               marginBottom: '16px',
//               '& > *': {
//                 flex: '1 1 calc(25% - 16px)',
//                 minWidth: 'auto'
//               }
//             }
//           }}
//         >
//           <Box>
//             <Person color="primary" />
//             <Box>
//               <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
//                 Patient Name
//               </Typography>
//               <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
//                 {patients?.MPD_PATIENT_NAME}
//               </Typography>
//             </Box>
//           </Box>

//           <Box>
//             <Home color="primary" />
//             <Box>
//               <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
//                 Address
//               </Typography>
//               <Typography variant="body1" fontWeight="500" sx={{
//                 '@media print': { fontSize: '1rem' },
//                 display: '-webkit-box',
//                 WebkitLineClamp: 1,
//                 WebkitBoxOrient: 'vertical',
//                 overflow: 'hidden'
//               }}>
//                 {patients?.MPD_ADDRESS || "Not specified"}
//               </Typography>
//             </Box>
//           </Box>

//           <Box>
//             <CalendarToday color="primary" />
//             <Box>
//               <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
//                 Date
//               </Typography>
//               <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
//                 {new Date().toLocaleDateString()}
//               </Typography>
//             </Box>
//           </Box>

//           <Box>
//             {patients?.MPD_GENDER === "Male" ? (
//               <Male color="primary" />
//             ) : (
//               <Female color="primary" />
//             )}
//             <Box>
//               <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
//                 Gender / Age
//               </Typography>
//               <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
//                 {patients?.MPD_GENDER} /{" "}
//                 {patients?.MPD_BIRTHDAY
//                   ? new Date().getFullYear() -
//                   new Date(patients.MPD_BIRTHDAY).getFullYear()
//                   : ""}
//               </Typography>
//             </Box>
//           </Box>
//         </Box>

//         <TableContainer
//           component={Paper}
//           elevation={0}
//           sx={{ border: "1px solid #eee", mb: 4 }}
//         >
//           <Table>
//             <TableHead sx={{ backgroundColor: "primary.main" }}>
//               <TableRow>
//                 <TableCell sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}>
//                   Drug Description
//                 </TableCell>
//                 <TableCell
//                   align="right"
//                   sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
//                 >
//                   Rate (Rs)
//                 </TableCell>
//                 <TableCell
//                   align="right"
//                   sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
//                 >
//                   Quantity
//                 </TableCell>
//                 <TableCell
//                   align="right"
//                   sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
//                 >
//                   Amount (Rs)
//                 </TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {invoicedetails?.Drugs?.map((medicinedetail, index) => (
//                 <TableRow key={index} hover>
//                   <TableCell sx={{ '@media print': { fontSize: '0.9rem' } }}>{medicinedetail.DrugName}</TableCell>
//                   <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
//                     {medicinedetail.MDD_RATE
//                       ? new Intl.NumberFormat('en-US', {
//                         minimumFractionDigits: 2,
//                         maximumFractionDigits: 2,
//                       }).format(Number(medicinedetail.MDD_RATE))
//                       : "0.00"}
//                   </TableCell>

//                   <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
//                     {medicinedetail.MDD_QUANTITY
//                       ? new Intl.NumberFormat('en-US').format(Number(medicinedetail.MDD_QUANTITY))
//                       : "0"}
//                   </TableCell>

//                   <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
//                     {medicinedetail.MDD_AMOUNT
//                       ? new Intl.NumberFormat('en-US', {
//                         minimumFractionDigits: 2,
//                         maximumFractionDigits: 2,
//                       }).format(Number(medicinedetail.MDD_AMOUNT))
//                       : "0.00"}
//                   </TableCell>
//                 </TableRow>
//               ))}

//               <TotalRow>
//                 <TableCell colSpan={2}></TableCell>
//                 <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
//                   Total  Fee:
//                 </TableCell>
//                 <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
//                   Rs: {new Intl.NumberFormat('en-US', {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2
//                   }).format(Number(calculateSubtotal()))}
//                 </TableCell>
//               </TotalRow>

//               <TotalRow>
//                 <TableCell colSpan={2}></TableCell>
//                 <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
//                   Service Charge 1:
//                 </TableCell>
//                 <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
//                   Rs: {new Intl.NumberFormat('en-US', {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2
//                   }).format(Number(treatmentamount))}
//                 </TableCell>
//               </TotalRow>

//               <TotalRow>
//                 <TableCell colSpan={2}></TableCell>
//                 <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
//                   Service Charge 2:
//                 </TableCell>
//                 <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
//                   Rs: {new Intl.NumberFormat('en-US', {
//                     minimumFractionDigits: 2,
//                     maximumFractionDigits: 2
//                   }).format(
//                     Number(calculateSubtotal()) + Number(treatmentamount)
//                   )}
//                 </TableCell>
//               </TotalRow>

//               <DiscountRow>
//                 <TableCell colSpan={1}></TableCell>
//                 <TableCell>
//                   <Typography fontWeight="bold" sx={{ '@media print': { fontSize: '1rem' } }}>Discount</Typography>
//                   <RadioGroup
//                     row
//                     value={discountType}
//                     onChange={(e) => setDiscountType(e.target.value)}
//                     sx={{ mt: 1 }}
//                   >
//                     <FormControlLabel
//                       value="percentage"
//                       control={<Radio size="small" />}
//                       label={<Typography sx={{ '@media print': { fontSize: '0.9rem' } }}>Percentage</Typography>}
//                     />
//                     <FormControlLabel
//                       value="fixed"
//                       control={<Radio size="small" />}
//                       label={<Typography sx={{ '@media print': { fontSize: '0.9rem' } }}>Fixed Amount</Typography>}
//                     />
//                   </RadioGroup>
//                 </TableCell>
//                 <TableCell align="right">
//                   <TextField
//                     type="number"
//                     size="small"
//                     value={discount}
//                     onChange={(e) => setDiscount(e.target.value)}
//                     inputProps={{
//                       min: "0",
//                       max:
//                         discountType === "percentage"
//                           ? "100"
//                           : parseFloat(calculateSubtotal()) +
//                           parseFloat(treatmentamount),
//                     }}
//                     sx={{ width: 120 }}
//                   />
//                 </TableCell>
//                 <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
//                   {discountType === "percentage"
//                     ? `${discount}%`
//                     : `Rs: ${discount}`}
//                 </TableCell>
//               </DiscountRow>

//               <TotalRow sx={{ backgroundColor: "primary.light" }}>
//                 <TableCell colSpan={2}></TableCell>
//                 <TableCell align="right" sx={{ color: "common.white", '@media print': { fontSize: '1.1rem' } }}>
//                   <Typography variant="h6">Final Amount:</Typography>
//                 </TableCell>
//                 <TableCell
//                   align="right"
//                   sx={{ color: "common.white", '@media print': { fontSize: '1.1rem' } }}
//                 >
//                   <Typography variant="h6">
//                     Rs: {new Intl.NumberFormat('en-US', {
//                       minimumFractionDigits: 2,
//                       maximumFractionDigits: 2
//                     }).format(Number(calculateTotalAmount()))}
//                   </Typography>
//                 </TableCell>
//               </TotalRow>
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Box
//           sx={{
//             mt: 6,
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "flex-end",
//           }}
//         >
//           <Box
//             sx={{
//               width: 300,
//               textAlign: "center",
//               p: 2,
//             }}
//           >
//             <Divider sx={{ mb: 2 }} />
//             <Typography variant="body1" color="text.secondary" sx={{ '@media print': { fontSize: '0.9rem' } }}>
//               Authorized Signature
//             </Typography>
//             <Typography variant="h6" fontWeight="bold" sx={{ mt: 2, '@media print': { fontSize: '1.1rem' } }}>
//               Aura Meditation
//             </Typography>
//           </Box>
//         </Box>
//       </StyledPaper>

//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           gap: 3,
//           mt: 4,
//           "@media print": {
//             display: "none",
//           },
//         }}
//         className="no-print"
//       >
//         <Tooltip title="Print standard invoice">
//           <Button
//             variant="contained"
//             color="primary"
//             startIcon={<Print />}
//             onClick={printInvoice}
//             sx={{ px: 4, py: 1.5 }}
//           >
//             Print Invoice
//           </Button>
//         </Tooltip>

//         <Tooltip title="Print thermal receipt with enhanced visibility">
//           <Button
//             variant="contained"
//             color="secondary"
//             startIcon={<ReceiptLong />}
//             onClick={() => setThermalPrintDialogOpen(true)}
//             sx={{ px: 4, py: 1.5 }}
//           >
//             Thermal Receipt
//           </Button>
//         </Tooltip>

//         <Tooltip title="Download as PDF">
//           <Button
//             variant="outlined"
//             color="primary"
//             startIcon={<Download />}
//             onClick={downloadInvoice}
//             sx={{ px: 4, py: 1.5 }}
//           >
//             Download PDF
//           </Button>
//         </Tooltip>
//       </Box>

//       {/* Thermal Printing Dialog with Enhanced Visibility */}
//       <ThermalPrintDialog
//         open={thermalPrintDialogOpen}
//         onClose={() => setThermalPrintDialogOpen(false)}
//         patients={patients}
//         invoicedetails={invoicedetails}
//         treatmentamount={treatmentamount}
//         discount={discount}
//         discountType={discountType}
//         calculateSubtotal={calculateSubtotal}
//         calculateTotalAmount={calculateTotalAmount}
//       />
//     </Container>
//   );
// }


import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Container,
  Box,
  Typography,
  Paper,
  Divider,
  Button,
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Radio,
  RadioGroup,
  FormControlLabel,
  TextField,
  Grid,
  Tooltip,
  CircularProgress,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Card,
  CardContent,
  Alert,
  Snackbar,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import {
  ArrowBack,
  Print,
  Download,
  LocalHospital,
  Person,
  Receipt,
  Phone,
  Email,
  Language,
  Home,
  CalendarToday,
  Male,
  Female,
  ReceiptLong,
  ContentCopy,
  CloudUpload,
  Usb,
  AutoAwesome,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import logo from "../assets/AuraLogo.png";
import html2pdf from "html2pdf.js";
import { NumericFormat } from 'react-number-format';
import auraBmpLogo from "../assets/AuraLogo.bmp";

const ThermalPrintDialog = ({ 
  open, 
  onClose, 
  patients, 
  invoicedetails, 
  treatmentamount, 
  discount, 
  discountType, 
  calculateSubtotal, 
  calculateTotalAmount 
}) => {
  const [isPrinting, setIsPrinting] = useState(false);
  const [printMethod, setPrintMethod] = useState('browser');
  const [status, setStatus] = useState('');

  const logoSource = auraBmpLogo;

  const getPatientName = () => {
    if (!patients) return 'N/A';
    return patients?.MPD_PATIENT_NAME || 'Unknown Patient';
  };

  const getInvoiceNumber = () => {
    if (!invoicedetails) return 'N/A';
    return invoicedetails?.MTD_SERIAL_NO || 'N/A';
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(value));
  };

  const calculateFinalSubtotal = () => {
    return Number(calculateSubtotal()) + Number(treatmentamount);
  };

  const calculateFinalTotal = () => {
    return Number(calculateTotalAmount());
  };

  const generateEscPosCommands = () => {
    const subtotal = calculateFinalSubtotal();
    const totalAmount = calculateFinalTotal();
    
    const currentDate = new Date().toLocaleDateString('en-LK');
    const currentTime = new Date().toLocaleTimeString('en-LK', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false 
    });

    const commands = [
      '\x1B\x40',
      '\x1B\x61\x01',
      '\x1B\x21\x30',
      'AURA MEDITATION CENTER\n',
      '\x1B\x21\x00',
      '\x1B\x61\x00',
      '================================\n',
      '\x1B\x61\x01',
      '\x1B\x45\x01',
      'PAYMENT RECEIPT\n',
      '\x1B\x45\x00',
      '================================\n',
      '\x1B\x61\x00',
      '\x1B\x45\x01',
      `Date: ${currentDate}\n`,
      `Time: ${currentTime}\n`,
      '\x1B\x45\x00',
      '--------------------------------\n',
      '\x1B\x61\x01',
      '\x1B\x45\x01',
      'PATIENT DETAILS\n',
      '\x1B\x45\x00',
      '--------------------------------\n',
      '\x1B\x61\x00',
      '\x1B\x45\x01',
      `Name: ${getPatientName()}\n`,
      `Address: ${patients?.MPD_ADDRESS || 'Not specified'}\n`,
      '\x1B\x45\x00',
      '--------------------------------\n',
      '\x1B\x61\x01',
      '\x1B\x45\x01',
      'BILLING DETAILS\n',
      '\x1B\x45\x00',
      '--------------------------------\n',
      '\x1B\x61\x00',
      '\x1B\x45\x01',
      'Item                Qty    Price     Amount\n',
      '\x1B\x45\x00',
      '--------------------------------\n',
    ];

    if (invoicedetails?.Drugs && invoicedetails.Drugs.length > 0) {
      invoicedetails.Drugs.forEach(medicinedetail => {
        const medicineName = medicinedetail.MDD_MATERIAL_NAME || medicinedetail.DrugName || '';
        const qty = (medicinedetail.MDD_QUANTITY || 0).toString().padStart(3);
        const rate = formatCurrency(medicinedetail.MDD_RATE || 0).padStart(8);
        const amount = formatCurrency(medicinedetail.MDD_AMOUNT || 0).padStart(10);
        
        commands.push(
          '\x1B\x45\x01',
          `${medicineName}\n`,
          `                    ${qty}   ${rate}  ${amount}\n`,
          '\x1B\x45\x00'
        );
      });
    } else {
      commands.push(
        '\x1B\x45\x01',
        'No medications\n',
        '\x1B\x45\x00'
      );
    }

    commands.push(
      '--------------------------------\n',
      ...(invoicedetails?.Drugs?.length > 0 ? [
        '\x1B\x45\x01',
        `Service Charge 1:       ${formatCurrency(calculateSubtotal())}\n`,
        '\x1B\x45\x00'
      ] : []),
      '\x1B\x45\x01',
      `Service Charge 2:       ${formatCurrency(treatmentamount)}\n`,
      '\x1B\x45\x00',
      ...(discount > 0 ? [
        '\x1B\x45\x01',
        `Discount:             ${
          discountType === 'percentage' ? 
          `-${discount}%` : 
          `-Rs. ${formatCurrency(discount)}`
        }\n`,
        '\x1B\x45\x00'
      ] : []),
      '================================\n',
      '\x1B\x21\x30',
      '\x1B\x45\x01',
      `TOTAL: Rs. ${formatCurrency(totalAmount)}\n`,
      '\x1B\x45\x00',
      '\x1B\x21\x00',
      '================================\n',
      '\n',
      '\x1B\x61\x01',
      '\x1B\x45\x01',
      'THANK YOU!\n',
      'Aura Meditation Center\n',
      '\x1B\x45\x00',
      '--------------------------------\n',
      '\x1B\x45\x01',
      `${new Date().toLocaleString('en-LK')}\n`,
      '\x1B\x45\x00',
      '\n\n\n\n',
      '\x1D\x56\x41\x03'
    );

    return commands.join('');
  };

  const handleBrowserPrint = () => {
  setIsPrinting(true);
  setStatus('Preparing print with black logo...');

  const subtotal = calculateFinalSubtotal();
  const totalAmount = calculateFinalTotal();

  const printContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Payment Receipt - Aura Meditation Center</title>
      <style>
        @media print {
          @page {
            margin: 0;
            size: 80mm 150mm;
            margin: 2mm;
          }
          
          body {
            margin: 0;
            padding: 2mm;
            font-family: 'Courier New', monospace;
            font-size: 12px;
            line-height: 1.3;
            width: 76mm;
            background: white;
            color: #000000;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
            font-weight: 600;
          }
          
          .receipt {
            width: 76mm;
            margin: 0 auto;
          }
          
          .header {
            text-align: center;
            margin-bottom: 4px;
          }
          
          .center {
            text-align: center;
          }
          
          .bold {
            font-weight: 800;
            color: #000000;
          }
          
          .large {
            font-size: 16px;
            font-weight: 800;
            color: #000000;
          }
          
          .x-large {
            font-size: 18px;
            font-weight: 900;
            color: #000000;
          }
          
          .divider {
            border-bottom: 2px solid #000;
            margin: 4px 0;
            height: 2px;
          }
          
          .double-divider {
            border-bottom: 3px solid #000;
            margin: 5px 0;
            height: 3px;
          }
          
          .text-left {
            text-align: left;
          }
          
          .text-right {
            text-align: right;
          }
          
          .row {
            display: flex;
            justify-content: space-between;
            margin: 3px 0;
            font-weight: 700;
            color: #000000;
          }

          .footer {
            text-align: center;
            margin-top: 12px;
            font-weight: 800;
            color: #000000;
          }
          
          .logo {
            text-align: center;
            margin-bottom: 6px;
          }
          
          .timestamp {
            text-align: center;
            font-weight: 800;
            color: #000000 !important;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
            margin-top: 6px;
            fontSize: 11px;
          }
          
          .bmp-logo {
            max-width: 35mm;
            height: auto;
            display: block;
            margin: 0 auto 3px auto;
             filter: invert(1) brightness(2) contrast(1000%) saturate(0%);
            -webkit-filter: invert(1) brightness(2) contrast(1000%) saturate(0%);
            image-rendering: pixelated;
            image-rendering: -webkit-optimize-contrast;
          }
          
          .items-table {
            width: 100%;
            border-collapse: collapse;
            font-weight: 700;
            color: #000000;
          }
          
          .items-table td {
            padding: 2px 0;
            font-size: 11px;
          }
          
          .total-row {
            font-weight: 900;
            font-size: 13px;
            color: #000000;
          }

          .section-title {
            font-weight: 900;
            font-size: 13px;
            color: #000000;
            text-align: center;
            margin: 4px 0;
          }

          .important-text {
            font-weight: 800;
            color: #000000;
            font-size: 12px;
          }

          .patient-details {
            font-weight: 700;
            color: #000000;
            font-size: 11px;
          }

          .medicine-item {
            margin: 2px 0;
            font-weight: 700;
          }

          .medicine-name {
            word-wrap: break-word;
            word-break: break-word;
            margin-bottom: 1px;
            font-size: 10px;
            line-height: 1.2;
          }

          .medicine-details {
            display: flex;
            justify-content: space-between;
            font-size: 12px;
            line-height: 1.3;
            font-weight: 800;
            margin-top: 2px;
          }

          .qty {
            font-size: 12px;
            font-weight: 900;
          }

          .price {
            font-size: 12px;
            font-weight: 900;
          }

          .amount {
            font-size: 12px;
            font-weight: 900;
          }

          .logo-container {
            background: white;
            padding: 3px;
            display: inline-block;
            margin-bottom: 3px;
          }
        }
        
        @media screen {
          body {
            background: #f5f5f5;
            padding: 20px;
          }
          .receipt {
            border: 2px dashed #666;
            background: white;
            padding: 10px;
          }
        }
      </style>
    </head>
    <body>
      <div class="receipt">
        <div class="logo">
          <div class="logo-container">
            <img src="${logoSource}" alt="Aura Meditation Center" class="bmp-logo">
          </div>
        </div>
        
        <div class="header">
          <div class="x-large">AURA MEDITATION CENTER</div>
          <div class="double-divider"></div>
          <div class="large">PAYMENT RECEIPT</div>
          <div class="double-divider"></div>
        </div>
        
        <div class="text-left important-text">
          <div class="row">
            <span>Date:</span>
            <span>${new Date().toLocaleDateString('en-LK')}</span>
          </div>
          <div class="row">
            <span>Time:</span>
            <span>${new Date().toLocaleTimeString('en-LK', { hour: '2-digit', minute: '2-digit', hour12: false })}</span>
          </div>
        </div>
        
        <div class="divider"></div>
        
        <div class="section-title">PATIENT DETAILS</div>
        <div class="divider"></div>
        
        <div class="text-left patient-details">
          <div class="row">
            <span>Name:</span>
            <span>${getPatientName()}</span>
          </div>
          <div class="row">
            <span>Address:</span>
            <span>${patients?.MPD_ADDRESS || 'Not specified'}</span>
          </div>
        </div>
        
        <div class="divider"></div>
        
        <div class="section-title">BILLING DETAILS</div>
        <div class="divider"></div>
        
        <div class="medicine-items">
          ${invoicedetails?.Drugs?.map(medicinedetail => `
            <div class="medicine-item">
              <div class="medicine-name important-text">
                ${medicinedetail.MDD_MATERIAL_NAME || medicinedetail.DrugName || ''}
              </div>
              <div class="medicine-details important-text">
                <span class="qty">Qty: ${medicinedetail.MDD_QUANTITY || 0}</span>
                <span class="price">Price: ${formatCurrency(medicinedetail.MDD_RATE || 0)}</span>
                <span class="amount">Amount: ${formatCurrency(medicinedetail.MDD_AMOUNT || 0)}</span>
              </div>
            </div>
          `).join('') || '<div class="medicine-item important-text">No medications</div>'}
        </div>
        
        <div class="divider"></div>
        
        <div class="text-left important-text">
          ${invoicedetails?.Drugs?.length > 0 ? `
          <div class="row">
            <span>Service Charge 1:</span>
            <span>Rs. ${formatCurrency(calculateSubtotal())}</span>
          </div>
          ` : ''}
          <div class="row">
            <span>Service Charge 2:</span>
            <span>Rs. ${formatCurrency(treatmentamount)}</span>
          </div>
          
          ${discount > 0 ? `
          <div class="row">
            <span>Discount:</span>
            <span>${discountType === 'percentage' ? `-${discount}%` : `-Rs. ${formatCurrency(discount)}`}</span>
          </div>
          ` : ''}
          <div class="row total-row">
            <span>TOTAL:</span>
            <span>Rs. ${formatCurrency(totalAmount)}</span>
          </div>
        </div>
        
        <div class="divider"></div>
        
        <div class="footer">
          <div class="bold">THANK YOU!</div>
          <div class="bold">Aura Meditation Center</div>
        </div>
        
        <div class="timestamp">
          <strong>Generated: ${new Date().toLocaleString('en-LK')}</strong>
        </div>
      </div>
      
      <script>
        window.onload = function() {
          setTimeout(function() {
            window.print();
            setTimeout(function() {
              window.close();
            }, 500);
          }, 500);
        };
      </script>
    </body>
    </html>
  `;

  const printWindow = window.open('', '_blank', 'width=400,height=600');
  if (printWindow) {
    printWindow.document.write(printContent);
    printWindow.document.close();
    setStatus('Print dialog opened with black logo');
  } else {
    setStatus('Failed to open print window. Please allow popups.');
  }
  
  setTimeout(() => {
    setIsPrinting(false);
    onClose();
  }, 2000);
};

  const handleDownloadEscPos = () => {
    setIsPrinting(true);
    setStatus('Generating ESC/POS file...');
    
    try {
      const escPosData = generateEscPosCommands();
      
      const blob = new Blob([escPosData], { type: 'application/octet-stream' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `payment-receipt-${getInvoiceNumber()}.txt`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      
      setStatus('ESC/POS file downloaded. Transfer to printer manually.');
      setTimeout(() => {
        setIsPrinting(false);
        onClose();
      }, 2000);
    } catch (error) {
      setStatus('Error generating file: ' + error.message);
      setIsPrinting(false);
    }
  };

  const handleServerPrint = async () => {
    setIsPrinting(true);
    setStatus('Sending to server printer...');
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/print/payment-receipt`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          patients,
          invoicedetails,
          treatmentamount,
          discount,
          discountType,
          subtotal: calculateSubtotal(),
          totalAmount: calculateTotalAmount(),
          type: 'thermal',
          timestamp: new Date().toISOString()
        }),
      });
      
      if (response.ok) {
        const result = await response.json();
        setStatus('Print job sent to server successfully!');
        setTimeout(() => {
          setIsPrinting(false);
          onClose();
        }, 1500);
      } else {
        throw new Error('Server returned error: ' + response.status);
      }
    } catch (error) {
      setStatus('Server printing failed: ' + error.message);
      setTimeout(() => {
        setStatus('Falling back to browser print...');
        handleBrowserPrint();
      }, 1500);
    }
  };

  const handlePrint = () => {
    switch (printMethod) {
      case 'browser':
        handleBrowserPrint();
        break;
      case 'server':
        handleServerPrint();
        break;
      case 'download':
        handleDownloadEscPos();
        break;
      default:
        handleBrowserPrint();
    }
  };

const printMethods = [
  {
    id: 'browser',
    name: 'Browser Thermal Print',
    description: 'Optimized for thermal printers with black logo',
    icon: <Print />,
  },
  {
    id: 'download',
    name: 'Download ESC/POS File',
    description: 'Download file for manual transfer to thermal printer',
    icon: <Download />,
  },
  {
    id: 'server',
    
    name: 'Server Print',
    description: 'Send to network/shared printer',
    icon: <CloudUpload />,
  }
];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Print Payment Receipt
        <Chip label="Darker Logo" color="primary" size="small" sx={{ ml: 1 }} />
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Select printing method for thermal receipt with darker logo and optimized text size
        </Typography>
        
        <FormControl fullWidth sx={{ mb: 3 }}>
          <Select
            value={printMethod}
            onChange={(e) => setPrintMethod(e.target.value)}
            disabled={isPrinting}
          >
            {printMethods.map(method => (
              <MenuItem key={method.id} value={method.id}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  {method.icon}
                  <Box>
                    <Typography variant="body2" fontWeight="bold">
                      {method.name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {method.description}
                    </Typography>
                  </Box>
                </Box>
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Card variant="outlined" sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Receipt Preview with Larger Qty/Price/Amount
            </Typography>
            <Paper 
              sx={{ 
                p: 2, 
                backgroundColor: '#f5f5f5', 
                fontFamily: 'Courier New, monospace', 
                fontSize: '12px',
                lineHeight: '1.3',
                border: '1px dashed #ccc',
                fontWeight: '600',
                color: '#000000'
              }}
            >
              <Box sx={{ textAlign: 'center', mb: 1 }}>
                <Box 
                  sx={{ 
                    display: 'inline-block', 
                    backgroundColor: 'Black', 
                    p: 0.5, 
                    border: '1px solid #000',
                    mb: 1
                  }}
                >
                  <img 
                    src={logoSource} 
                    alt="Aura Logo" 
                    style={{ 
                      maxWidth: '35mm', 
                      height: 'auto',
                      filter: 'invert(1) brightness(2) contrast(1000%) saturate(0%)',
                      backgroundColor: 'black'
                    }}
                  />
                </Box>
              </Box>
              
              <div style={{ textAlign: 'center', fontWeight: '900', fontSize: '14px', color: '#000000' }}>
                AURA MEDITATION CENTER
              </div>
              <div style={{ textAlign: 'center', fontWeight: '800', color: '#000000' }}>PAYMENT RECEIPT</div>
              
              <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '700', color: '#000000' }}>
                <span>Date:</span>
                <span>{new Date().toLocaleDateString('en-LK')}</span>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '700', color: '#000000' }}>
                <span>Name:</span>
                <span>{getPatientName()}</span>
              </div>          
              
              <div style={{ borderBottom: '2px solid #000', margin: '4px 0' }}></div>
              <div style={{ textAlign: 'center', fontWeight: '900', color: '#000000', fontSize: '13px' }}>BILLING DETAILS</div>
              <div style={{ borderBottom: '2px solid #000', margin: '4px 0' }}></div>
              
              <div>
                {invoicedetails?.Drugs?.map((medicinedetail, index) => (
                  <div key={index} style={{ margin: '2px 0' }}>
                    <div style={{ fontWeight: '700', color: '#000000', wordWrap: 'break-word', fontSize: '10px', lineHeight: '1.2' }}>
                      {medicinedetail.MDD_MATERIAL_NAME || medicinedetail.DrugName || ''}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', fontWeight: '900', color: '#000000', lineHeight: '1.5', marginTop: '2px' }}>
                      <span style={{ fontSize: '12px', fontWeight: '900' }}>Qty: {medicinedetail.MDD_QUANTITY || 0}</span>
                      <span style={{ fontSize: '12px', fontWeight: '900' }}>Price: {formatCurrency(medicinedetail.MDD_RATE || 0)}</span>
                      <span style={{ fontSize: '12px', fontWeight: '900' }}>Amount: {formatCurrency(medicinedetail.MDD_AMOUNT || 0)}</span>
                    </div>
                  </div>
                )) || <div style={{ fontWeight: '700', color: '#000000', fontSize: '10px' }}>No medications</div>}
              </div>
              
              <div style={{ borderBottom: '2px solid #000', margin: '4px 0' }}></div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '700', color: '#000000' }}>
                <span>Service Charge 1:</span>
                <span> {formatCurrency(calculateSubtotal())}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '700', color: '#000000' }}>
                <span>Service Charge 2:</span>
                <span> {formatCurrency(treatmentamount)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '900', color: '#000000', fontSize: '13px' }}>
                <span>TOTAL:</span>
                <span>Rs. {formatCurrency(calculateTotalAmount())}</span>
              </div>
              
              <div style={{ borderBottom: '2px solid #000', margin: '4px 0' }}></div>
              <div style={{ textAlign: 'center', fontWeight: '800', color: '#000000' }}>
                THANK YOU!<br/>Aura Meditation Center
              </div>
              
              <div style={{ textAlign: 'center', marginTop: '8px', fontWeight: '800', color: '#000000', fontSize: '11px' }}>
                Generated: {new Date().toLocaleString('en-LK')}
              </div>
            </Paper>
          </CardContent>
        </Card>

        {status && (
          <Alert severity="info" sx={{ mb: 2 }}>
            {status}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isPrinting}>
          Cancel
        </Button>
        <Button 
          onClick={handlePrint}
          variant="contained"
          disabled={isPrinting}
          startIcon={isPrinting ? <CircularProgress size={16} /> : <Print />}
        >
          {isPrinting ? 'Printing...' : 'Print Receipt'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

// ... rest of the code remains exactly the same as your previous working version
// (StyledPaper, HeaderBox, TotalRow, DiscountRow, InvoiceNumberBox, and main Invoice component)

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  marginTop: theme.spacing(3),
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[3],
  maxWidth: 1500,
  margin: "0 auto",
  "@media print": {
    boxShadow: "none",
    padding: theme.spacing(3),
    border: "1px solid #ddd",
  },
}));

const HeaderBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: theme.spacing(4),
  "@media (max-width: 600px)": {
    flexDirection: "column",
    gap: theme.spacing(2),
    alignItems: "flex-start",
  },
  "@media print": {
    flexDirection: "row",
    alignItems: "center",
  },
}));

const TotalRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  "& td": {
    fontWeight: "bold",
    fontSize: "1.1rem",
  },
}));

const DiscountRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  "& td": {
    padding: theme.spacing(2),
  },
}));

const InvoiceNumberBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: 'white',
  padding: '6px 12px',
  borderRadius: '16px',
  display: 'inline-block',
  marginTop: theme.spacing(1),
  fontSize: '0.875rem',
  fontWeight: 500,
  '-webkit-print-color-adjust': 'exact',
  'color-adjust': 'exact',
  'print-color-adjust': 'exact',
}));

export default function Invoice() {
  const { patientId, serial_no } = useParams();
  const [patients, setPatients] = useState(null);
  const [invoicedetails, setInvoicedetails] = useState(null);
  const [treatmentamount, setTreatmentamount] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [discountType, setDiscountType] = useState("percentage");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [thermalPrintDialogOpen, setThermalPrintDialogOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [treatmentRes, patientRes] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/Treatment/patient/record/${patientId}/${serial_no}`
          ),
          axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/Patient/${patientId}`
          ),
        ]);
        setInvoicedetails(treatmentRes.data);
        setTreatmentamount(treatmentRes.data.MTD_AMOUNT || 0);
        setPatients(patientRes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.response?.data?.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [patientId, serial_no]);

  const calculateSubtotal = () => {
    if (invoicedetails && invoicedetails.Drugs) {
      const total = invoicedetails.Drugs.reduce(
        (total, drug) => total + drug.MDD_AMOUNT,
        0
      );
      return total.toFixed(2);
    }
    return 0;
  };

  const calculateTotalAmount = () => {
    const subtotal =
      parseFloat(calculateSubtotal()) + parseFloat(treatmentamount);
    let totalAmount = subtotal;

    if (discountType === "percentage") {
      totalAmount -= (subtotal * discount) / 100;
    } else {
      totalAmount -= discount;
    }

    return totalAmount.toFixed(2);
  };

  const printInvoice = () => {
    const noPrintElements = document.querySelectorAll('.no-print');
    noPrintElements.forEach(element => {
      element.style.display = 'none';
    });

    const printStyles = document.createElement('style');
    printStyles.innerHTML = `
    @media print {
      body * {
        visibility: hidden;
      }
      
      #invoice-content, #invoice-content * {
        visibility: visible;
      }
      
      #invoice-content {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
      }
      
      .MuiContainer-root {
        max-width: none !important;
        padding: 0 !important;
        margin: 0 !important;
      }
      
      .MuiPaper-root {
        box-shadow: none !important;
        border: none !important;
        margin: 0 !important;
        padding: 20px !important;
      }
      
      @page {
        size: A4;
        margin: 15mm;
      }
    }
  `;

    document.head.appendChild(printStyles);
    window.print();

    setTimeout(() => {
      document.head.removeChild(printStyles);
      noPrintElements.forEach(element => {
        element.style.display = '';
      });
    }, 100);
  };

  const downloadInvoice = () => {
    const element = document.getElementById("invoice-content");
    const opt = {
      margin: [10, 10, 10, 10],
      filename: `invoice_${patientId}_${serial_no}.pdf`,
      image: {
        type: "jpeg",
        quality: 0.98
      },
      html2canvas: {
        scale: 2,
        logging: false,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        ignoreElements: function (element) {
          return element.classList.contains('no-print');
        }
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
        putOnlyUsedFonts: true,
        floatPrecision: 16
      },
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
    };
    const tempStyles = document.createElement('style');
    tempStyles.innerHTML = `
      .invoice-number-pdf {
        backgroundColor: theme.palette.secondary.main;
        color: white !important;
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
      }
    `;
    document.head.appendChild(tempStyles);

    html2pdf().set(opt).from(element).save().then(() => {
      document.head.removeChild(tempStyles);
    });
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="80vh"
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Paper elevation={3} sx={{ p: 3, textAlign: "center" }}>
          <Typography variant="h6" color="error">
            {error}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={() => window.location.reload()}
          >
            Retry
          </Button>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ mb: 3 }} className="no-print">
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate(-1)}
          variant="outlined"
        >
          Back to Records
        </Button>
      </Box>

      <StyledPaper elevation={3} id="invoice-content">
        <HeaderBox>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Avatar
              src={logo}
              alt="Medicare Logo"
              variant="rounded"
              sx={{ width: 80, height: 80, '@media print': { width: 60, height: 60 } }}
            />
            <Box>
              <Typography variant="h5" fontWeight="bold" color="primary" sx={{ '@media print': { fontSize: '2rem' } }}>
                AURA MEDITATION
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
                No:128/1,Pahala karagahamuna,Kadawatha
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
                Tel: 0114532108|0117905805 | Email: akdldhshana@gmail.com
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ '@media print': { fontSize: '1.5rem' } }}>
                Web: www.auracare.lk
              </Typography>
            </Box>
          </Box>

          <Box sx={{ textAlign: "right" }}>
            <Typography variant="h5" color="primary" fontWeight="bold" sx={{ '@media print': { fontSize: '1.5rem' } }}>
              Payment Receipt
            </Typography>
            <InvoiceNumberBox className="invoice-number-pdf">
              Invoice - {invoicedetails?.MTD_SERIAL_NO || "N/A"}
            </InvoiceNumberBox>
          </Box>
        </HeaderBox>

        <Divider sx={{ my: 3 }} />

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: { xs: 2, sm: 3 },
            mb: 4,
            alignItems: "center",
            justifyContent: "space-between",
            '& > *': {
              flex: { xs: '1 1 100%', sm: '1 1 calc(25% - 24px)', md: '1 1 calc(25% - 24px)' },
              minWidth: { xs: '100%', sm: '200px' },
              display: "flex",
              alignItems: "center",
              gap: 1,
            },
            '@media print': {
              gap: 2,
              marginBottom: '16px',
              '& > *': {
                flex: '1 1 calc(25% - 16px)',
                minWidth: 'auto'
              }
            }
          }}
        >
          <Box>
            <Person color="primary" />
            <Box>
              <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
                Patient Name
              </Typography>
              <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
                {patients?.MPD_PATIENT_NAME}
              </Typography>
            </Box>
          </Box>

          <Box>
            <Home color="primary" />
            <Box>
              <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
                Address
              </Typography>
              <Typography variant="body1" fontWeight="500" sx={{
                '@media print': { fontSize: '1rem' },
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden'
              }}>
                {patients?.MPD_ADDRESS || "Not specified"}
              </Typography>
            </Box>
          </Box>

          <Box>
            <CalendarToday color="primary" />
            <Box>
              <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
                Date
              </Typography>
              <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
                {new Date().toLocaleDateString()}
              </Typography>
            </Box>
          </Box>

          <Box>
            {patients?.MPD_GENDER === "Male" ? (
              <Male color="primary" />
            ) : (
              <Female color="primary" />
            )}
            <Box>
              <Typography variant="subtitle2" color="text.secondary" sx={{ '@media print': { fontSize: '0.8rem' } }}>
                Gender / Age
              </Typography>
              <Typography variant="body1" fontWeight="500" sx={{ '@media print': { fontSize: '1rem' } }}>
                {patients?.MPD_GENDER} /{" "}
                {patients?.MPD_BIRTHDAY
                  ? new Date().getFullYear() -
                  new Date(patients.MPD_BIRTHDAY).getFullYear()
                  : ""}
              </Typography>
            </Box>
          </Box>
        </Box>

        <TableContainer
          component={Paper}
          elevation={0}
          sx={{ border: "1px solid #eee", mb: 4 }}
        >
          <Table>
            <TableHead sx={{ backgroundColor: "primary.main" }}>
              <TableRow>
                <TableCell sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}>
                  Drug Description
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
                >
                  Rate (Rs)
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
                >
                  Quantity
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ color: "common.white", fontWeight: "bold", '@media print': { fontSize: '0.9rem' } }}
                >
                  Amount (Rs)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invoicedetails?.Drugs?.map((medicinedetail, index) => (
                <TableRow key={index} hover>
                  <TableCell sx={{ '@media print': { fontSize: '0.9rem' } }}>{medicinedetail.DrugName}</TableCell>
                  <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
                    {medicinedetail.MDD_RATE
                      ? new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(Number(medicinedetail.MDD_RATE))
                      : "0.00"}
                  </TableCell>

                  <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
                    {medicinedetail.MDD_QUANTITY
                      ? new Intl.NumberFormat('en-US').format(Number(medicinedetail.MDD_QUANTITY))
                      : "0"}
                  </TableCell>

                  <TableCell align="right" sx={{ '@media print': { fontSize: '0.9rem' } }}>
                    {medicinedetail.MDD_AMOUNT
                      ? new Intl.NumberFormat('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }).format(Number(medicinedetail.MDD_AMOUNT))
                      : "0.00"}
                  </TableCell>
                </TableRow>
              ))}

              <TotalRow>
                <TableCell colSpan={2}></TableCell>
                <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
                  Total  Fee:
                </TableCell>
                <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
                  Rs: {new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }).format(Number(calculateSubtotal()))}
                </TableCell>
              </TotalRow>

              <TotalRow>
                <TableCell colSpan={2}></TableCell>
                <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
                  Service Charge 1:
                </TableCell>
                <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
                  Rs: {new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }).format(Number(treatmentamount))}
                </TableCell>
              </TotalRow>

              <TotalRow>
                <TableCell colSpan={2}></TableCell>
                <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
                  Service Charge 2:
                </TableCell>
                <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
                  Rs: {new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }).format(
                    Number(calculateSubtotal()) + Number(treatmentamount)
                  )}
                </TableCell>
              </TotalRow>

              <DiscountRow>
                <TableCell colSpan={1}></TableCell>
                <TableCell>
                  <Typography fontWeight="bold" sx={{ '@media print': { fontSize: '1rem' } }}>Discount</Typography>
                  <RadioGroup
                    row
                    value={discountType}
                    onChange={(e) => setDiscountType(e.target.value)}
                    sx={{ mt: 1 }}
                  >
                    <FormControlLabel
                      value="percentage"
                      control={<Radio size="small" />}
                      label={<Typography sx={{ '@media print': { fontSize: '0.9rem' } }}>Percentage</Typography>}
                    />
                    <FormControlLabel
                      value="fixed"
                      control={<Radio size="small" />}
                      label={<Typography sx={{ '@media print': { fontSize: '0.9rem' } }}>Fixed Amount</Typography>}
                    />
                  </RadioGroup>
                </TableCell>
                <TableCell align="right">
                  <TextField
                    type="number"
                    size="small"
                    value={discount}
                    onChange={(e) => setDiscount(e.target.value)}
                    inputProps={{
                      min: "0",
                      max:
                        discountType === "percentage"
                          ? "100"
                          : parseFloat(calculateSubtotal()) +
                          parseFloat(treatmentamount),
                    }}
                    sx={{ width: 120 }}
                  />
                </TableCell>
                <TableCell align="right" sx={{ '@media print': { fontSize: '1rem' } }}>
                  {discountType === "percentage"
                    ? `${discount}%`
                    : `Rs: ${discount}`}
                </TableCell>
              </DiscountRow>

              <TotalRow sx={{ backgroundColor: "primary.light" }}>
                <TableCell colSpan={2}></TableCell>
                <TableCell align="right" sx={{ color: "common.white", '@media print': { fontSize: '1.1rem' } }}>
                  <Typography variant="h6">Final Amount:</Typography>
                </TableCell>
                <TableCell
                  align="right"
                  sx={{ color: "common.white", '@media print': { fontSize: '1.1rem' } }}
                >
                  <Typography variant="h6">
                    Rs: {new Intl.NumberFormat('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }).format(Number(calculateTotalAmount()))}
                  </Typography>
                </TableCell>
              </TotalRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Box
          sx={{
            mt: 6,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
          }}
        >
          <Box
            sx={{
              width: 300,
              textAlign: "center",
              p: 2,
            }}
          >
            <Divider sx={{ mb: 2 }} />
            <Typography variant="body1" color="text.secondary" sx={{ '@media print': { fontSize: '0.9rem' } }}>
              Authorized Signature
            </Typography>
            <Typography variant="h6" fontWeight="bold" sx={{ mt: 2, '@media print': { fontSize: '1.1rem' } }}>
              Aura Meditation
            </Typography>
          </Box>
        </Box>
      </StyledPaper>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 3,
          mt: 4,
          "@media print": {
            display: "none",
          },
        }}
        className="no-print"
      >
        <Tooltip title="Print standard invoice">
          <Button
            variant="contained"
            color="primary"
            startIcon={<Print />}
            onClick={printInvoice}
            sx={{ px: 4, py: 1.5 }}
          >
            Print Invoice
          </Button>
        </Tooltip>

        <Tooltip title="Print thermal receipt with darker logo">
          <Button
            variant="contained"
            color="secondary"
            startIcon={<ReceiptLong />}
            onClick={() => setThermalPrintDialogOpen(true)}
            sx={{ px: 4, py: 1.5 }}
          >
            Thermal Receipt
          </Button>
        </Tooltip>

        <Tooltip title="Download as PDF">
          <Button
            variant="outlined"
            color="primary"
            startIcon={<Download />}
            onClick={downloadInvoice}
            sx={{ px: 4, py: 1.5 }}
          >
            Download PDF
          </Button>
        </Tooltip>
      </Box>

      <ThermalPrintDialog
        open={thermalPrintDialogOpen}
        onClose={() => setThermalPrintDialogOpen(false)}
        patients={patients}
        invoicedetails={invoicedetails}
        treatmentamount={treatmentamount}
        discount={discount}
        discountType={discountType}
        calculateSubtotal={calculateSubtotal}
        calculateTotalAmount={calculateTotalAmount}
      />
    </Container>
  );
}